const es =
{
  "nav": {
    "features": "Funciones",
    "benefits": "Beneficios",
    "pricing": "Precios",
    "contact": "Contacto",
    "faq": "Preguntas frecuentes",
      "signIn": "Iniciar sesión",
      "getStarted": "Comenzar",
      "forBusiness": "Para Empresas"
    },
  "landing": {
    "nav": {
      "features": "Funciones",
      "benefits": "Beneficios",
      "pricing": "Precios",
      "contact": "Contacto",
      "faq": "Preguntas",
      "signIn": "Entrar",
      "getStarted": "Comenzar",
      "forBusiness": "Empresas"
    },
    "hero": {
      "badge": "Impulsado por IA",
      "title1": "Transforma clientes en promotores de Marca",
      "title2": "y multiplica tus prospectos",
      "subtitle": "Lance programas de referidos potentes que impulsen el crecimiento, aumenten la fidelización y escalen su negocio con nuestra plataforma integral.",
      "startTrial": "Iniciar prueba gratuita",
      "viewPricing": "Ver precios",
      "noCreditCard": "No se requiere tarjeta de crédito",
      "freeTrial": "Prueba gratuita de 14 días",
      "cancelAnytime": "Cancele cuando quiera"
    },
    "capabilities": {
      "unlimited": "Ilimitado",
      "scalability": "Escalabilidad",
      "realtime": "Tiempo real",
      "processing": "Procesando",
      "uptime": "99.9%",
      "sla": "SLA de disponibilidad",
      "enterprise": "Empresa",
      "ready": "Listo"
    },
    "features": {
      "title": "Todo lo que necesita para",
      "titleHighlight": "tener éxito",
      "subtitle": "Funciones potentes diseñadas para crear, gestionar y optimizar sus programas de referidos con facilidad.",
      "referralManagement": {
        "title": "Gestión de referidos",
        "description": "Sistema completo para gestionar y rastrear todos sus referidos en tiempo real con analítica detallada."
      },
      "growthAnalytics": {
        "title": "Analítica de crecimiento",
        "description": "Analítica avanzada e información para comprender el rendimiento de su programa de referidos."
      },
      "rewardSystem": {
        "title": "Sistema de recompensas",
        "description": "Sistema de recompensas flexible y personalizable para incentivar a sus clientes."
      },
      "fraudPrevention": {
        "title": "Prevención de fraude",
        "description": "Medidas de seguridad avanzadas para prevenir fraudes y garantizar la integridad del programa."
      },
      "instantAutomation": {
        "title": "Automatización instantánea",
        "description": "Automatice el seguimiento de referidos, la distribución de recompensas y las notificaciones."
      },
      "realtimeReports": {
        "title": "Informes en tiempo real",
        "description": "Obtenga informes e información al instante sobre el rendimiento de su programa de referidos."
      }
    },
    "benefits": {
      "title": "Por qué elegir",
      "titleHighlight": "Enrola",
      "subtitle": "Construido con tecnología de vanguardia para impulsar el crecimiento de su negocio.",
      "increaseSales": {
        "title": "Aumentar ventas",
        "description": "Impulse sus ventas hasta un 300% con programas de referidos estratégicos.",
        "stat": "+300%"
      },
      "customerGrowth": {
        "title": "Crecimiento de clientes",
        "description": "Adquiera nuevos clientes a un costo 5 veces menor que el marketing tradicional.",
        "stat": "5x ROI"
      },
      "customerLoyalty": {
        "title": "Fidelización de clientes",
        "description": "Aumente significativamente la retención de clientes y el valor de por vida.",
        "stat": "+85%"
      },
      "fastDeployment": {
        "title": "Implementación rápida",
        "description": "Ponga en marcha su programa de referidos en menos de 24 horas.",
        "stat": "< 24h"
      }
    },
    "pricing": {
      "title": "Simple y transparente",
      "titleHighlight": "Precios",
      "subtitle": "Elija el plan ideal para su negocio. Escale a medida que crece.",
      "trialNote": "Todos los planes incluyen una prueba gratuita de 14 días. No se requiere tarjeta de crédito.",
      "startTrial": "Iniciar prueba gratuita",
      "startTrialShort": "Comenzar",
      "contactSales": "Contactar ventas",
      "contactSalesShort": "Contactar",
      "perMonth": "mes",
      "customPrice": "Personalizado",
      "plans": [
        {
          "id": "starter",
          "name": "Starter",
          "price": "49",
          "period": "month",
          "description": "Ideal para pequeños negocios que inician con referidos",
          "features": [
            "Hasta 500 referidos/mes",
            "Panel de analítica básico",
            "Notificaciones por correo",
            "Sistema de recompensas estándar",
            "Soporte por correo",
            "Acceso a API"
          ],
          "popular": false
        },
        {
          "id": "professional",
          "name": "Professional",
          "price": "149",
          "period": "month",
          "description": "Para empresas en crecimiento con necesidades avanzadas",
          "features": [
            "Hasta 5.000 referidos/mes",
            "Analítica e informes avanzados",
            "Notificaciones multicanal",
            "Reglas de recompensa personalizadas",
            "Soporte prioritario",
            "API avanzada y webhooks",
            "Marca personalizada",
            "Detección de fraude"
          ],
          "popular": true
        },
        {
          "id": "enterprise",
          "name": "Enterprise",
          "price": "Custom",
          "period": "",
          "description": "Soluciones a medida para grandes organizaciones",
          "features": [
            "Referidos ilimitados",
            "Solución white-label",
            "Gestor de cuenta dedicado",
            "Integraciones personalizadas",
            "Soporte telefónico 24/7",
            "Funciones de seguridad avanzadas",
            "Desarrollo a medida",
            "Garantía SLA",
            "Soporte multi-tenant"
          ],
          "popular": false
        }
      ]
    },
    "sceneNav": {
      "sections": "Secciones de la página",
      "hero": "Inicio",
      "capabilities": "Resumen",
      "features": "Funciones",
      "benefits": "Beneficios",
      "pricing": "Precios",
      "contact": "Contacto",
      "faq": "Preguntas",
      "footer": "Comenzar"
    },
    "contact": {
      "title": "Contacto y",
      "titleHighlight": "Soporte",
      "subtitle": "Póngase en contacto con nuestro equipo para soporte, consultas u oportunidades de colaboración.",
      "immediate": "¿Necesita asistencia inmediata?",
      "immediateDesc": "Nuestro equipo de soporte está disponible 24/7 para ayudarle con cualquier consulta o problema.",
      "contactSupport": "Contactar soporte",
      "salesInquiry": "Consulta comercial",
      "methods": {
        "support": {
          "title": "Soporte por correo",
          "description": "Obtenga ayuda de nuestro equipo de soporte"
        },
        "sales": {
          "title": "Consultas comerciales",
          "description": "¿Interesado en nuestro plan Enterprise?"
        },
        "tech": {
          "title": "Soporte técnico",
          "description": "¿Necesita asistencia técnica?"
        }
      }
    },
    "faq": {
      "title": "Preguntas",
      "titleHighlight": "frecuentes",
      "subtitle": "Todo lo que necesita saber sobre Enrola.",
      "items": [
        {
          "question": "¿Qué tan rápido puedo empezar?",
          "answer": "Puede configurar su programa de referidos en menos de 15 minutos. Nuestro panel intuitivo facilita configurar recompensas, personalizar la marca e invitar clientes."
        },
        {
          "question": "¿Qué integraciones ofrecen?",
          "answer": "Ofrecemos integraciones con las principales plataformas CRM, herramientas de email marketing, procesadores de pago y plataformas de comercio electrónico. También disponemos de una API robusta para integraciones personalizadas."
        },
        {
          "question": "¿Cómo previenen el fraude?",
          "answer": "Nuestro sistema avanzado de detección de fraude utiliza aprendizaje automático para identificar actividades sospechosas, cuentas duplicadas y referidos inválidos en tiempo real."
        },
        {
          "question": "¿Puedo personalizar la estructura de recompensas?",
          "answer": "¡Por supuesto! Tiene total flexibilidad para crear niveles de recompensa personalizados, definir distintas recompensas para quien refiere y quien es referido, e implementar campañas por tiempo limitado."
        },
        {
          "question": "¿Hay contrato o puedo cancelar en cualquier momento?",
          "answer": "Todos nuestros planes son mensuales, sin contratos a largo plazo. Puede cambiar de plan o cancelar en cualquier momento sin penalizaciones."
        },
        {
          "question": "¿Ofrecen soporte al cliente?",
          "answer": "¡Sí! Ofrecemos soporte por correo en todos los planes, soporte prioritario en planes Professional y soporte telefónico 24/7 para clientes Enterprise."
        }
      ]
    },
    "cta": {
      "title": "¿Listo para hacer crecer su negocio?",
      "subtitle": "Comience a construir programas de referidos exitosos con nuestra plataforma potente y lista para empresas.",
      "startTrial": "Comience su prueba gratuita",
      "viewPricing": "Ver precios",
      "trialNote": "Sin tarjeta de crédito • Prueba gratuita de 14 días • Cancele cuando quiera"
    },
    "footer": {
      "description": "Enrola: la plataforma de referidos para convertir clientes en promotores de marca y escalar su crecimiento.",
      "product": "Producto",
      "company": "Empresa",
      "legal": "Legal",
      "security": "Seguridad de nivel empresarial",
      "copyright": "© 2025 Enrola. Todos los derechos reservados.",
      "visitWebsite": "Visitar enrolanow.com",
      "securityInfo": "Información de seguridad",
      "features": "Funciones",
      "pricing": "Precios",
      "integrations": "Integraciones",
      "api": "API",
      "aboutUs": "Sobre nosotros",
      "blog": "Blog",
      "careers": "Empleo",
      "contact": "Contacto",
      "privacyPolicy": "Política de privacidad",
      "termsOfService": "Términos del servicio",
      "securityLink": "Seguridad",
      "gdpr": "GDPR"
    }
  },
  "legal": {
    "pageTitle": "Términos de Servicio y Políticas de Privacidad",
    "effectiveDate": "Fecha de entrada en vigor",
    "termsHeading": "Términos de Servicio Generales",
    "privacyHeading": "Política de Privacidad para Estados Unidos",
    "backToHome": "Volver al inicio",
    "backToRegistration": "Volver al registro",
    "agreementPrefix": "He leído y acepto los",
    "termsLink": "Términos de Servicio",
    "agreementAnd": "y la",
    "privacyLink": "Política de Privacidad",
    "mustAccept": "Debe aceptar los términos y la política de privacidad para continuar"
  },
  "login": {
    "welcome": "Bienvenido al",
    "future": "Futuro de los Referidos",
    "subtitle": "Únase a miles de referidores exitosos que ganan con nuestra plataforma premium. Comience hoy y desbloquee un potencial de ingresos ilimitado.",
    "welcomeBack": "Bienvenido de nuevo",
    "signInAccount": "Inicie sesión en su cuenta",
    "email": "Correo electrónico",
    "enterEmail": "Ingrese su correo electrónico",
    "password": "Contraseña",
    "enterPassword": "Ingrese su contraseña",
    "signIn": "Iniciar sesión",
    "backToHome": "Volver al inicio",
    "forgotPassword": "¿Olvidó su contraseña?",
    "features": {
      "launch": {
        "title": "Impulse su éxito",
        "desc": "Empiece a ganar con nuestro potente sistema de referidos"
      },
      "secure": {
        "title": "Seguro y confiable",
        "desc": "Seguridad de nivel empresarial para su tranquilidad"
      },
      "premium": {
        "title": "Experiencia premium",
        "desc": "Disfrute de las funciones premium y el soporte de nuestra plataforma"
      }
    },
    "welcomeBackToast": "¡Bienvenido de nuevo!",
    "errorToast": "Ocurrió un error inesperado",
    "signInFailed": "No se pudo iniciar sesión",
    "businessPortalPrompt": "¿Administrador de empresa?"
  },
  "forgotPassword": {
    "title": "Recupere su",
    "titleHighlight": "Contraseña",
    "subtitle": "Ingrese su correo electrónico y le enviaremos un enlace seguro para restablecer su contraseña.",
    "recoverPassword": "Recuperar contraseña",
    "sendLink": "Le enviaremos un enlace seguro a su correo",
    "email": "Correo electrónico",
    "enterEmail": "Ingrese su correo electrónico",
    "sendRecoveryLink": "Enviar enlace de recuperación",
    "backToLogin": "← Volver a iniciar sesión",
    "features": {
      "secure": {
        "title": "Recuperación segura",
        "desc": "Sistema seguro de recuperación de contraseña"
      },
      "protection": {
        "title": "Protección de la cuenta",
        "desc": "Su información está protegida en todo momento"
      },
      "support": {
        "title": "Soporte rápido",
        "desc": "Recupere el acceso a su cuenta rápidamente"
      }
    },
    "successMessage": "Si el correo existe, se ha enviado un enlace de recuperación",
    "errorMessage": "Error al procesar la solicitud",
    "connectionError": "Error de conexión",
    "recoveryLinkSent": "Enlace de recuperación enviado",
    "couldNotProcess": "No se pudo procesar su solicitud"
  },
  "errorBoundary": {
    "title": "Error de la aplicación",
    "message": "Algo salió mal. Por favor, recargue la página.",
    "details": "Detalles del error (solo desarrollo)",
    "reload": "Recargar página"
  },
  "resetPassword": {
    "new": "Nuevo",
    "titleHighlight": "Contraseña",
    "subtitle": "Cree una nueva contraseña segura para proteger su cuenta.",
    "createNewPassword": "Crear nueva contraseña",
    "chooseSecure": "Elija una contraseña segura para su cuenta",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirmar contraseña",
    "enterNewPassword": "Ingrese su nueva contraseña",
    "confirmNewPassword": "Confirme su nueva contraseña",
    "updatePassword": "Actualizar contraseña",
    "backToLogin": "← Volver a iniciar sesión",
    "passwordStrength": "Fortaleza de la contraseña:",
    "weak": "Débil",
    "medium": "Medio",
    "strong": "Fuerte",
    "passwordsMatch": "Las contraseñas coinciden",
    "passwordsNoMatch": "Las contraseñas no coinciden",
    "features": {
      "security": {
        "title": "Máxima seguridad",
        "desc": "Su nueva contraseña está protegida con cifrado"
      },
      "instant": {
        "title": "Acceso instantáneo",
        "desc": "Puede acceder a su cuenta de inmediato"
      },
      "continuity": {
        "title": "Continuidad garantizada",
        "desc": "Retome sus actividades sin interrupciones"
      }
    },
    "invalidLink": "Enlace no válido",
    "invalidLinkDesc": "El enlace de recuperación no es válido o ha expirado.",
    "requestNewLink": "Solicitar nuevo enlace",
    "passwordMismatch": "Las contraseñas no coinciden",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
    "passwordUpdated": "Contraseña actualizada correctamente",
    "resetError": "Error al restablecer la contraseña",
    "connectionError": "Error de conexión"
  },
  "brand": {
    "productName": "Enrola",
    "byline": "por Elantar",
    "fullName": "Enrola por Elantar",
    "logoAlt": "Logo de Enrola por Elantar",
    "edition": "Plataforma de referidos y recompensas"
  },
  "common": {
    "loading": "Cargando...",
    "saving": "Guardando...",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "delete": "Eliminar",
    "edit": "Editar",
    "create": "Crear",
    "update": "Actualizar",
    "close": "Cerrar",
    "search": "Buscar",
    "searchPlaceholder": "Buscar...",
    "clearSearch": "Limpiar búsqueda",
    "noResults": "No se encontraron resultados",
    "error": "Error",
    "success": "Éxito",
    "yes": "Sí",
    "no": "No",
    "back": "Volver",
    "next": "Siguiente",
    "previous": "Anterior",
    "submit": "Enviar",
    "actions": "Acciones",
    "status": "Estado",
    "date": "Fecha",
    "name": "Nombre",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "phoneCopied": "¡Número de teléfono copiado al portapapeles!",
    "copyPhone": "Toca para copiar el número de teléfono",
    "copyFailed": "No se pudo copiar",
    "username": "Nombre de usuario",
    "password": "Contraseña",
    "showPassword": "Mostrar contraseña",
    "hidePassword": "Ocultar contraseña",
    "user": "Usuario",
    "admin": "Admin",
    "member": "Miembro",
    "administrator": "Administrador",
    "vendor": "Representante",
    "trendingUp": "Tendencia al alza",
    "trendingDown": "Tendencia a la baja",
    "noActivity": "Sin actividad",
    "daysShort": ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
    "languageSwitcher": "Cambiar idioma",
    "skipToContent": "Saltar al contenido",
    "expandSidebar": "Expandir barra lateral",
    "collapseSidebar": "Contraer barra lateral",
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú",
    "tabs": "Pestañas",
    "confirmTitle": "Confirmar acción",
    "confirmDestructiveTitle": "Confirmar eliminación",
    "loadingContent": "Cargando contenido",
    "loadingDashboard": "Cargando panel",
    "table": {
      "searchPlaceholder": "Buscar en la tabla...",
      "filterAll": "Todos",
      "clearFilters": "Limpiar filtros",
      "showingResults": "Mostrando {count} de {total}",
      "noMatchingRows": "No hay filas que coincidan",
      "filterByStatus": "Estado",
      "filterByVendor": "Representante",
      "filterByEvent": "Evento",
      "filterReady": "Listos",
      "filterErrors": "Con errores"
    },
    "stateDistribution": {
      "dateRange": "Rango de fechas",
      "dateFrom": "Desde",
      "dateTo": "Hasta",
      "allDates": "Todas las fechas",
      "apply": "Aplicar",
      "vendor": "Representante",
      "allVendors": "Todos los representantes",
      "clearFilters": "Limpiar filtros",
      "historicalMode": "Histórico",
      "historicalModeHint": "Mostrar conteos acumulados de cada etapa alcanzada en el tiempo",
      "historicalModeActiveHint": "Modo histórico activo — cuenta cada transición de etapa",
      "loading": "Cargando datos de distribución...",
      "exportPdf": "Exportar PDF",
      "exportExcel": "Exportar Excel",
      "exportSuccess": "Exportación completada",
      "exportFailed": "Error al exportar",
      "noData": "No hay datos para exportar",
      "state": "Estado",
      "count": "Cantidad",
      "percentage": "Porcentaje",
      "chart": "Gráfica",
      "sheetName": "Distribución",
      "reportSubtitle": "Reporte de distribución por estado",
      "printedOn": "Impreso el",
      "printedBy": "Impreso por",
      "appliedFilters": "Filtros aplicados",
      "noFiltersApplied": "Sin filtros aplicados",
      "summary": "Resumen",
      "totalRecords": "Total de registros",
      "chartOverview": "Vista del gráfico",
      "detailedData": "Datos detallados",
      "noDetailRecords": "No hay registros que coincidan con los filtros seleccionados.",
      "clientName": "Cliente",
      "email": "Correo",
      "phone": "Teléfono",
      "referrals": "Referidos",
      "createdAt": "Creado",
      "stateUpdatedAt": "Estado actualizado",
      "representatives": "Representantes",
      "prospectName": "Prospecto",
      "address": "Dirección",
      "status": "Estado",
      "saleType": "Tipo de venta",
      "updatedAt": "Actualizado",
      "representative": "Representante",
      "detailSheetName": "Detalle",
      "summarySheetName": "Resumen",
      "filterByVendorButton": "Filtrar por vendedor",
      "vendorFilterModalTitle": "Seleccionar vendedor",
      "vendorFilterAllTitle": "Todos los vendedores",
      "vendorFilterAllDesc": "Ver métricas de toda la plataforma",
      "vendorFilterClients": "Clientes",
      "vendorFilterReferrals": "Referidos",
      "vendorFilterProspects": "Prospectos",
      "vendorFilterMemberSince": "Desde {date}",
      "vendorFilterSelected": "Seleccionado",
      "vendorFilterNoVendors": "No hay vendedores registrados"
    }
  },
  "ux": {
    "nextBestAction": {
      "greeting": "Hola, {name}",
      "clientInvite": {
        "title": "Invita a tu primer contacto",
        "description": "Comparte tu enlace o código QR para empezar a ganar puntos.",
        "cta": "Abrir herramientas de invitación",
        "motivations": [
          "Un amigo más y estás más cerca de tu próximo regalo.",
          "Una invitación hoy puede desbloquear tu siguiente premio.",
          "Escanea, comparte y sonríe. Tu red crece contigo."
        ]
      },
      "clientInviteMore": {
        "title": "Haz crecer tu red hoy",
        "description": "Envía tu enlace a alguien que se beneficie del programa.",
        "cta": "Compartir enlace de referido",
        "motivations": [
          "Un amigo más y estás más cerca de tu próximo regalo.",
          "Una invitación hoy puede desbloquear tu siguiente premio.",
          "Estás construyendo algo genial — mantén la curiosidad."
        ]
      },
      "clientClaim": {
        "title": "Ya puedes canjear una recompensa",
        "description": "Usa tus puntos — la entrega se rastrea en tu cuenta.",
        "cta": "Canjear recompensa",
        "motivations": [
          "Tus puntos trabajan por ti — ¡canjea esa recompensa!",
          "Ese regalo es tuyo. Ve y canjéalo.",
          "Te lo ganaste. Es hora de reclamar tu premio."
        ]
      },
      "clientTrackGift": {
        "title": "Un regalo está en camino",
        "description": "Sigue el estado de entrega y confirma la recepción cuando llegue.",
        "cta": "Rastrear mi regalo",
        "motivations": [
          "Tu regalo se mueve — mira dónde va ahora.",
          "¡Casi llega! Rastrea la entrega y prepárate a sonreír.",
          "Algo bueno viene en camino. Echa un vistazo al estado."
        ]
      },
      "clientBrowse": {
        "title": "Explora el catálogo de recompensas",
        "description": "Mira qué puedes ganar y cuántos puntos necesita cada regalo.",
        "cta": "Ver recompensas",
        "motivations": [
          "Tus puntos trabajan por ti. ¡Sigue así!",
          "¿Curioso por lo que puedes desbloquear? Mira el catálogo.",
          "Estás construyendo algo genial — mantén la curiosidad."
        ]
      },
      "clientShortAction": {
        "title": "Completa tu acción del día",
        "description": "Pasos pequeños y constantes hacen crecer tu red más rápido.",
        "cta": "Hacerlo ahora",
        "motivations": [
          "Una victoria rápida hoy mantiene el impulso.",
          "Pasos pequeños, gran red — termina la acción de hoy.",
          "Tú puedes. Cierra esa acción corta."
        ]
      },
      "vendorProspect": {
        "title": "Crea un nuevo prospecto",
        "description": "Agrega un lead, da seguimiento y enróllalo cuando esté listo.",
        "cta": "Nuevo prospecto",
        "motivations": [
          "¿Listo para enrolar a ese cliente?",
          "Un prospecto más hoy cambia toda la semana.",
          "Sonríe, llama, enrola. Hagamos un día fuerte.",
          "Tu pipeline te espera — que el siguiente paso cuente."
        ]
      },
      "vendorGifts": {
        "title": "Regalos pendientes de entrega",
        "description": "Los clientes esperan sus recompensas — marca las entregas para mantener la confianza.",
        "cta": "Revisar regalos pendientes",
        "motivations": [
          "Los clientes esperan sus regalos — mantén la confianza alta.",
          "Entregas pendientes. Hagamos mover esas recompensas.",
          "Una actualización rápida de entrega alegra el día de alguien."
        ]
      },
      "vendorShortAction": {
        "title": "Completa tu acción del día",
        "description": "Pasos pequeños y constantes hacen crecer tu pipeline más rápido.",
        "cta": "Hacerlo ahora",
        "motivations": [
          "Hoy sí lograremos esa meta de ventas — mucho ánimo.",
          "Tu pipeline te espera — que el siguiente paso cuente.",
          "Pasos pequeños hoy, pipeline más fuerte mañana."
        ]
      },
      "adminGifts": {
        "title": "Revisa entregas de regalos pendientes",
        "description": "Los canjes necesitan aprobación del admin antes de que el vendedor entregue al cliente.",
        "cta": "Abrir regalos pendientes",
        "motivations": [
          "Mantén el pipeline sano y los regalos en movimiento.",
          "Una revisión rápida de regalos mantiene el programa afilado.",
          "Hay entregas esperando — límpialas y mantén el ritmo."
        ]
      },
      "adminNotifications": {
        "title": "Notificaciones sin leer",
        "description": "Ponte al día con los eventos del programa antes de que se conviertan en retrasos.",
        "cta": "Abrir notificaciones",
        "motivations": [
          "Una revisión rápida mantiene el programa afilado.",
          "Tu equipo cuenta con dirección clara hoy.",
          "Ponte al día rápido — las pequeñas victorias de ops se acumulan."
        ]
      },
      "adminPipeline": {
        "title": "Revisa tu pipeline de usuarios",
        "description": "Verifica vendedores, clientes y distribución por etapa para detectar cuellos de botella.",
        "cta": "Gestionar usuarios",
        "motivations": [
          "Lidera con claridad. Tus representantes te siguen.",
          "Tu equipo cuenta con dirección clara hoy.",
          "Las pequeñas victorias de ops se acumulan — tú tienes el control."
        ]
      }
    },
    "actionOutcome": {
      "dismiss": "Entendido",
      "undo": "Deshacer",
      "nextStepLabel": "Siguiente:",
      "giftAdminDelivered": {
        "title": "Regalo entregado al vendedor",
        "description": "El canje pasó a la cola del vendedor para entrega al cliente.",
        "nextStep": "El vendedor marcará la entrega cuando el cliente reciba el regalo."
      },
      "giftVendorDelivered": {
        "title": "Regalo marcado como entregado",
        "description": "El cliente ya puede confirmar la recepción y dejar una reseña.",
        "nextStep": "Recibirás aviso cuando el cliente confirme la recepción."
      },
      "giftConfirmed": {
        "title": "Recepción confirmada — ¡gracias!",
        "description": "Tu reseña ayuda a los vendedores y queda en tu historial de recompensas.",
        "nextStep": "Explora más recompensas o invita amigos para ganar puntos."
      },
      "rewardClaimed": {
        "title": "Recompensa canjeada con éxito",
        "description": "Tu solicitud fue enviada y los puntos fueron descontados.",
        "nextStep": "Rastrea la preparación y entrega en Regalos en tránsito."
      },
      "clientAdvanced": {
        "title": "Etapa del cliente actualizada",
        "description": "El pipeline refleja el nuevo estado de inmediato.",
        "nextStep": "Da seguimiento al cliente o avanza cuando se cumpla el siguiente hito."
      },
      "prospectEnrolled": {
        "title": "Prospecto inscrito como cliente",
        "description": "Se eliminó de prospectos y se agregó a tu lista de clientes.",
        "nextStep": "Comparte herramientas de referido o agenda el primer seguimiento en Mis clientes."
      }
    },
    "viewState": {
      "retry": "Reintentar",
      "loadFailed": "No se pudo cargar esta sección"
    },
    "validation": {
      "emailRequired": "El correo es obligatorio",
      "emailInvalid": "Ingresa un correo electrónico válido",
      "passwordRequired": "La contraseña es obligatoria",
      "passwordMin": "La contraseña debe tener al menos 6 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden",
      "fieldRequired": "Este campo es obligatorio",
      "companyRequired": "El nombre de la empresa es obligatorio",
      "termsRequired": "Debes aceptar los términos para continuar",
      "ratingsRequired": "Califica el producto y al vendedor",
      "rewardNameRequired": "El nombre de la recompensa es obligatorio",
      "pointsRequired": "El valor en puntos es obligatorio"
    },
    "onboarding": {
      "exploreFirst": "Explorar el panel primero",
      "exploreHint": "Puedes elegir tu recompensa en cualquier momento desde la pestaña de recompensas."
    }
  },
  "apiErrors": {
    "emailAndPasswordRequired": "El correo y la contraseña son obligatorios",
    "invalidEmail": "Correo electrónico no válido",
    "invalidCredentials": "Credenciales no válidas",
    "adminUseEnterprisePortal": "Los administradores de empresa deben iniciar sesión en el portal empresarial",
    "companyNotFound": "Empresa no encontrada",
    "companyFieldsRequired": "Nombre de empresa, correo y contraseña son obligatorios",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
    "emailAlreadyRegistered": "El correo ya está registrado",
    "registrationFailed": "No se pudo completar el registro",
    "missingRequiredFields": "Faltan campos obligatorios",
    "companyContextRequired": "Se requiere contexto de empresa. Use un enlace de referido o indique el slug de la empresa.",
    "usernameAlreadyExists": "El nombre de usuario ya existe",
    "emailAlreadyExists": "El correo ya existe",
    "dateOfBirthRequired": "La fecha de nacimiento es obligatoria",
    "invalidDateOfBirth": "Fecha de nacimiento no válida",
    "dateOfBirthMustBePast": "La fecha de nacimiento debe ser anterior a hoy",
    "minRegistrationAge": "Debe tener al menos {minAge} años para registrarse",
    "vendorAccessRequired": "Se requiere acceso de representante",
    "vendorNotFound": "Representante no encontrado",
    "prospectNotFound": "Prospecto no encontrado",
    "prospectEmailRequiredForEnroll": "El prospecto debe tener correo para inscribirse como cliente",
    "clientEmailAlreadyExists": "Ya existe un cliente con este correo",
    "prospectNameRequired": "El nombre es obligatorio",
    "invalidProspectStatus": "Estado no válido: {status}",
    "prospectionLevelRange": "El nivel de prospección debe estar entre 0 y 5",
    "prospectionLevelInvalid": "El nivel de prospección debe ser un número entre 0 y 5",
    "invalidBooleanValue": "Valor booleano no válido",
    "invalidHousingType": "El tipo de vivienda debe ser OWN o RENT",
    "appointmentTimesRequired": "La hora de inicio y fin son obligatorias",
    "appointmentEndAfterStart": "La hora de fin debe ser posterior a la de inicio",
    "invalidTimeFormat": "La hora debe usar el formato HH:MM",
    "invalidTimeValue": "Valor de hora no válido",
    "notAuthenticated": "No autenticado",
    "adminAccessRequired": "Se requiere acceso de administrador",
    "companyContextRequiredShort": "Se requiere contexto de empresa",
    "signInFailed": "No se pudo iniciar sesión",
    "registrationFailedGeneric": "No se pudo completar el registro",
    "companyRegistrationFailed": "No se pudo crear la cuenta de empresa",
    "companySignInFailed": "No se pudo iniciar sesión en la empresa",
    "cannotReachServer": "No se puede conectar al servidor. ¿Está el backend en ejecución?",
    "validationError": "Error de validación",
    "addressSearchUnavailable": "Búsqueda de direcciones no disponible",
    "emailRequired": "El correo es obligatorio",
    "passwordRequired": "La contraseña es obligatoria",
    "invalidOrExpiredResetLink": "Enlace de restablecimiento no válido o expirado",
    "noDataProvided": "No se enviaron datos",
    "nameCannotBeEmpty": "El nombre no puede estar vacío",
    "currentPasswordRequired": "La contraseña actual es obligatoria",
    "currentPasswordIncorrect": "La contraseña actual es incorrecta",
    "excelFileRequired": "Se requiere un archivo de Excel",
    "couldNotReadSpreadsheet": "No se pudo leer la hoja de cálculo",
    "emptySpreadsheet": "Hoja de cálculo vacía",
    "missingNameColumn": "Falta la columna \"name\" en la primera fila",
    "videoNotFound": "Video no encontrado",
    "videoSaveFailed": "No se pudo guardar el video",
    "titleRequired": "El título es obligatorio",
    "titleTooLong": "El título es demasiado largo",
    "videoAudienceRequired": "Seleccione al menos una audiencia: clientes o representantes",
    "videoUrlRequired": "Se requiere una URL de video",
    "videoFileRequired": "Se requiere un archivo de video",
    "invalidVideoSource": "El origen debe ser url o archivo",
    "invalidSortOrder": "El orden debe ser un número",
    "invalidVideoUrl": "URL de video no válida"
  },
  "statsCard": {
    "vsLastPeriod": "vs. período anterior",
    "last7Days": "Últimos 7 días",
    "periodToggleLabel": "Periodo de analíticas",
    "periods": {
      "weekly": "Semanal",
      "monthly": "Mensual",
      "yearly": "Anual",
      "all": "Histórico"
    },
    "trendWeekly": "Últimos 7 días",
    "trendMonthly": "Este mes",
    "trendYearly": "Este año",
    "trendAll": "Últimos 12 meses"
  },
  "analytics": {
    "platformActivity": "Actividad de la plataforma (últimos 7 días)",
    "chartNewUsers": "Nuevos usuarios",
    "chartReferrals": "Referidos",
    "chartClicks": "Clics",
    "chartConversions": "Conversiones",
    "clientsCount": "{count} clientes",
    "pointsCount": "{count} puntos",
    "referralsShort": "referidos",
    "performanceTrends": "Tendencias de rendimiento (últimos 7 días)",
    "clientProgressStates": "Estados de progreso del cliente",
    "thisMonthPerformance": "Rendimiento de este mes",
    "topPerformingClient": "Cliente con mejor rendimiento",
    "successfulReferrals": "{count} referidos exitosos",
    "noClientData": "Aún no hay datos de clientes",
    "clicksConversions": "Clics y conversiones (últimos 7 días)",
    "outOfTotalLinks": "De {total} enlaces en total",
    "totalSuccessfulReferrals": "Total de referidos exitosos",
    "earnPointsMilestone": "Gana puntos con cada hito de referidos",
    "eyebrow": "Información"
  },
  "dashboard": {
    "title": "Panel",
    "subtitle": "Resumen de su actividad",
    "loading": "Cargando su panel...",
    "rewardPoints": "Puntos de recompensa",
    "conversions": "Conversiones",
    "lifetimePoints": "Puntos acumulados",
    "last7Days": "Últimos 7 días",
    "referrals": "Referidos",
    "analytics": "Analítica",
    "network": "Red",
    "rewards": "Recompensas",
    "activeLinks": "Enlaces activos",
    "totalClicks": "Clics totales",
    "yourEarnedRewardPoints": "Sus puntos de recompensa ganados",
    "successfulReferralConversions": "Conversiones de referidos exitosas",
    "viewRewardPoints": "Consulte sus puntos de recompensa y las recompensas disponibles",
    "trackEarnedPoints": "Consulte cómo ha ganado sus puntos de recompensa",
    "startReferringClients": "¡Empiece a referir clientes para ganar puntos de recompensa!",
    "conversionsToGo": "conversiones restantes",
    "welcomeBack": "¡Bienvenido de nuevo, {name}!",
    "crushingIt": "¡Lo está haciendo genial! Su programa de referidos tiene un rendimiento excelente.",
    "proMember": "Miembro Pro",
    "loadingDashboard": "Cargando su panel...",
    "failedToLoadAnalytics": "No se pudieron cargar los datos de analítica",
    "failedToLoadNetwork": "No se pudieron cargar los datos de la red",
    "nextMilestone": "Próximo hito",
    "growthRate": "Tasa de crecimiento",
    "newClicks": "Nuevos clics",
    "pointsHistory": "Historial de puntos",
    "noPointsHistoryYet": "Aún no hay historial de puntos",
    "searchPointsHistory": "Buscar por cliente o fecha...",
    "filterByEventState": "Filtrar por evento",
    "noMatchingPointsHistory": "Ningún registro coincide con tu búsqueda o filtros.",
    "date": "Fecha",
    "event": "Evento",
    "referredClient": "Cliente referido",
    "pointsEarned": "Puntos ganados",
    "joined": "Registrado",
    "trackPerformance": "Supervise su rendimiento y métricas de crecimiento",
    "manageReferralLinks": "Gestione y supervise sus enlaces de referidos",
    "referralNetwork": "Su red de referidos y conexiones",
    "stayUpdated": "Manténgase al día con las últimas actividades",
    "customizeAccount": "Personalice su cuenta y preferencias",
    "performanceOverview": "¡Bienvenido de nuevo, {name}! Aquí tiene un resumen de su rendimiento.",
    "vsLastPeriod": "vs. período anterior",
    "recentReferralLinks": "Enlaces de referidos recientes",
    "noReferralLinks": "Aún no hay enlaces de referidos",
    "createFirstLink": "Cree su primer enlace de referidos para empezar a ganar comisiones.",
    "createLink": "Crear enlace",
    "quickActions": "Acciones rápidas",
    "viewAnalytics": "Ver analítica",
    "manageReferrals": "Gestionar referidos",
    "viewNetwork": "Ver red",
    "referralLinks": "Enlaces de referidos",
    "manageTrack": "Gestione y rastree todos sus enlaces de referidos",
    "yourNetwork": "Su red",
    "peopleReferred": "Personas que ha referido a la plataforma",
    "networkStats": "Estadísticas de la red",
    "totalReferred": "Total referidos",
    "activeMembers": "Miembros activos",
    "totalReferralsMade": "Total de referidos realizados",
    "networkMembers": "Miembros de la red",
    "loadingRewards": "Cargando recompensas...",
    "currentPoints": "Puntos actuales",
    "yourReferrals": "Sus referidos",
    "nextReward": "Próxima recompensa",
    "availableRewards": "Recompensas disponibles",
    "welcomeRewardsTitle": "Regalos de bienvenida",
    "welcomeRewardsSubtitle": "Elige cualquiera de estos tres regalos al canjear tu bono de bienvenida — mismo costo en puntos.",
    "catalogRewardsTitle": "Catálogo",
    "catalogRewardsSubtitle": "Gana más puntos refiriendo amigos y desbloquea estos productos.",
    "noPointsHistory": "Aún no hay historial de puntos",
    "noRewardsAvailable": "No hay recompensas disponibles en este momento",
    "failedToLoadRewards": "No se pudieron cargar las recompensas",
    "errorLoadingReferralLinks": "Error al cargar enlaces de referidos",
    "rewardClaimed": "¡Recompensa reclamada!",
    "thisWeekPerformance": "Rendimiento de esta semana",
    "redeemSubtitle": "Canjee sus puntos por recompensas increíbles",
    "available": "Disponible",
    "noDescription": "Sin descripción disponible",
    "points": "puntos",
    "moreNeeded": "faltan {count}",
    "checkBackLater": "¡Vuelva pronto para ver nuevas recompensas!",
    "settings": "Configuración",
    "notifications": "Notificaciones",
    "linkCreated": "¡Enlace de referido creado correctamente!",
    "errorCreatingLink": "Error al crear el enlace de referido",
    "createNewLink": "Crear nuevo enlace",
    "createFirstLinkBtn": "Cree su primer enlace",
    "claimReward": "Reclamar recompensa",
    "giftOnTheWay": "Tu regalo está en camino",
    "claimFailed": "No se pudo reclamar la recompensa",
    "historicalTotal": "Total histórico:",
    "percentComplete": "{percent}% completado",
    "noMoreGoals": "No hay más metas configuradas",
    "creating": "Creando...",
    "totalLabel": "Total",
    "activeLabel": "Activos",
    "completedLabel": "Completados",
    "noMoreGoalsReached": "No hay más metas o ya las alcanzaste"
  },
  "pendingGifts": {
    "title": "Regalos pendientes",
    "adminSubtitle": "Entregue recompensas a representantes y haga seguimiento de las entregas a clientes.",
    "vendorSubtitle": "Entregue los regalos reclamados a sus clientes referidos.",
    "awaitingHandoff": "Pendientes de entrega al representante",
    "withVendor": "Con representante — pendiente de entrega al cliente",
    "readyToDeliver": "Listos para entregar al cliente",
    "recentlyCompleted": "Completados recientemente",
    "claimedByLine": "Reclamado por {name}",
    "pointsLabel": "pts usados",
    "noVendorAssigned": "Sin representante asignado",
    "markDeliveredToVendor": "Marcar entregado al representante",
    "markDeliveredToClient": "Marcar entregado al cliente",
    "completed": "Entregado",
    "processing": "Procesando…",
    "adminDeliveredSuccess": "Regalo marcado como entregado al representante",
    "vendorDeliveredSuccess": "Regalo marcado como entregado al cliente",
    "actionFailed": "No se pudo actualizar el estado del regalo",
    "confirmAdminDeliverTitle": "¿Entregar el regalo al vendedor?",
    "confirmAdminDeliverMessage": "El vendedor será responsable de entregar esta recompensa al cliente. Esta acción no se puede deshacer desde esta pantalla.",
    "confirmVendorDeliverTitle": "¿Marcar el regalo como entregado?",
    "confirmVendorDeliverMessage": "Se pedirá al cliente que confirme la recepción y deje una reseña. Asegúrate de que el regalo fue entregado realmente.",
    "failedToLoad": "Error al cargar regalos pendientes",
    "noAwaitingHandoff": "No hay regalos pendientes de entrega",
    "noAwaitingHandoffDesc": "Las nuevas reclamaciones de clientes aparecerán aquí.",
    "noPendingGifts": "No hay regalos para entregar",
    "noPendingGiftsDesc": "Cuando el administrador le entregue un regalo, aparecerá aquí.",
    "awaitingAdminHandoff": "Esperando entrega de la empresa",
    "awaitingAdminHandoffDesc": "Su cliente reclamó un regalo. El administrador lo preparará para usted.",
    "waitingForAdminBadge": "Esperando al admin",
    "awaitingClientConfirmation": "Entregados — esperando confirmación del cliente",
    "awaitingClientConfirmationDesc": "Marcó estos regalos como entregados. El cliente debe confirmar la recepción.",
    "awaitingClientBadge": "Esperando confirmación",
    "vendorDaysRemaining": "Tiene {days} día(s) para entregar este regalo",
    "vendorFutureDeadline": "Cuando reciba este regalo, tendrá {days} día(s) para entregarlo al cliente",
    "vendorOverdueWarning": "Retraso en la entrega — aviso de retraso (día {day})",
    "vendorPastDeadline": "El plazo de entrega venció — por favor entregue lo antes posible"
  },
  "giftsInTransit": {
    "title": "Regalos en camino",
    "subtitle": "Siga el estado de sus recompensas y confirme cuando las reciba.",
    "onTheWaySection": "En camino",
    "deliveredSection": "Entregados por su representante",
    "deliveredSectionDesc": "Su representante indicó que ya le entregó el regalo. Confírmelo y deje una reseña rápida.",
    "preparingBadge": "Preparando su regalo",
    "onTheWayBadge": "En camino con su representante",
    "deliveredByVendorBadge": "Entregado por el representante",
    "confirmReceipt": "Confirmar recepción",
    "confirmSuccess": "¡Gracias! Su recepción fue confirmada.",
    "confirmFailed": "No se pudo confirmar la recepción",
    "failedToLoad": "Error al cargar sus regalos",
    "emptyTitle": "No tiene regalos en seguimiento",
    "emptyDesc": "Cuando canjee una recompensa y el administrador la entregue al representante, aparecerá aquí.",
    "noOnTheWay": "No hay regalos en camino en este momento.",
    "noDelivered": "No hay regalos pendientes de confirmación.",
    "noVendor": "Sin representante asignado",
    "pointsLabel": "pts",
    "processing": "Procesando…",
    "reviewModalTitle": "¿Cómo fue su experiencia con {name}?",
    "reviewModalDesc": "Califique el producto y su experiencia con el representante. Solo toma un momento.",
    "productRatingLabel": "Calificación del producto",
    "vendorRatingLabel": "Experiencia con el representante",
    "reviewTextLabel": "Comentario (opcional)",
    "reviewTextPlaceholder": "Cuéntenos brevemente su experiencia…",
    "ratingsRequired": "Seleccione una calificación para el producto y el representante",
    "submitReview": "Confirmar y enviar reseña",
    "cancel": "Cancelar",
    "clientDeliveryPromise": "Recibirá su regalo en menos de {days} día(s)"
  },
  "myContacts": {
    "title": "Mis contactos",
    "subtitle": "Conecte Google Contactos e invite a sus contactos por SMS con su enlace de referido.",
    "importFromGoogle": "Importar desde Google",
    "selectFromPhone": "Importar desde Google",
    "importing": "Conectando con Google…",
    "importSuccess": "{created} contacto(s) añadido(s), {updated} actualizado(s)",
    "importFailed": "No se pudieron guardar los contactos",
    "importEmpty": "No se encontraron contactos con número de teléfono",
    "googleImportHint": "Iniciará sesión en Google y autorizará a Enrola a leer sus contactos. Solo se importan contactos con teléfono.",
    "googleImportSuccess": "Contactos de Google importados: {created} añadidos, {updated} actualizados",
    "googleImportFailed": "No se pudieron importar los contactos desde Google",
    "googleImportCancelled": "Autorización de Google cancelada",
    "googleImportNoPhoneContacts": "No hay contactos de Google con número de teléfono",
    "googleNotConfigured": "La importación desde Google aún no está configurada. El administrador debe definir GOOGLE_CLIENT_ID y GOOGLE_CLIENT_SECRET.",
    "androidImportHint": "Android detectado: importe desde Google o elija contactos directamente de su teléfono.",
    "iosImportHint": "iPhone detectado: importe desde Google o traiga contactos de la app Contactos mediante tarjeta (.vcf).",
    "desktopImportHint": "Importe sus contactos desde Google. Funciona en cualquier navegador.",
    "importFromPhone": "Elegir del teléfono",
    "importFromICloud": "Importar desde Contactos (iPhone)",
    "importingPhone": "Abriendo contactos…",
    "importingVCard": "Leyendo tarjeta de contacto…",
    "phonePickerUnsupported": "Su navegador no puede abrir la agenda del teléfono. Use la importación de Google.",
    "vcardFailed": "No se pudo leer el archivo de contacto",
    "iosVCardSteps": "En Contactos: abra una persona → Compartir → toque la tarjeta (.vcf) → elija Enrola o guárdela en Archivos y súbala aquí. Repita por cada contacto.",
    "secureTitle": "Almacenados de forma segura en la plataforma",
    "secureDesc": "Su lista se guarda en su cuenta y solo usted puede verla. El acceso a Google se usa una vez para importar sus contactos.",
    "totalContacts": "Total de contactos",
    "invitedContacts": "Invitados",
    "pendingInvites": "Sin invitar aún",
    "searchPlaceholder": "Buscar por nombre, teléfono o correo…",
    "emptyTitle": "Aún no tiene contactos",
    "emptyDesc": "Conecte su cuenta de Google para importar contactos e invitarlos con un toque.",
    "emptyDescDesktop": "Importe contactos desde Google y gestione las invitaciones desde cualquier dispositivo.",
    "columnName": "Nombre",
    "columnPhone": "Teléfono",
    "columnEmail": "Correo",
    "columnStatus": "Estado",
    "columnActions": "Acciones",
    "statusInvited": "Invitado",
    "statusPending": "Pendiente",
    "inviteSms": "Invitar por SMS",
    "inviting": "Abriendo SMS…",
    "inviteOpened": "SMS abierto — envíe el mensaje cuando esté listo",
    "inviteFailed": "No se pudo abrir el SMS para este contacto",
    "invalidPhone": "Este contacto no tiene un número de teléfono válido",
    "noInviteLink": "Su enlace de referido aún no está listo",
    "desktopCopied": "Teléfono y mensaje copiados — envíe el SMS desde su teléfono",
    "removeContact": "Eliminar contacto",
    "confirmDelete": "¿Eliminar a \"{name}\" de su lista?",
    "deletedSuccess": "Contacto eliminado",
    "deleteFailed": "No se pudo eliminar el contacto",
    "failedToLoad": "Error al cargar sus contactos"
  },
  "vendorReviews": {
    "title": "Reseñas de Representantes",
    "subtitle": "Opiniones de clientes sobre regalos entregados y la experiencia con cada representante.",
    "deliveredBy": "Entregado por",
    "receivedBy": "Recibido por",
    "confirmedOn": "Confirmado el",
    "productRating": "Producto",
    "vendorRating": "Representante",
    "noComment": "Sin comentario escrito",
    "emptyTitle": "Aún no hay reseñas",
    "emptyDesc": "Cuando los clientes confirmen la recepción de un regalo, sus reseñas aparecerán aquí.",
    "failedToLoad": "Error al cargar las reseñas"
  },
  "platformAdmin": {
    "superAdminBadge": "Super Admin",
    "adminFallback": "Admin",
    "welcome": "Bienvenido, {name}",
    "homeSubtitle": "Visibilidad y control total sobre empresas, usuarios, ventas y configuraciones de la plataforma.",
    "viewCompanies": "Ver empresas",
    "viewAnalytics": "Ver analítica de ventas",
    "openSettings": "Abrir centro de configuración",
    "totalCompanies": "Empresas",
    "activeTenants": "Tenants activos en la plataforma",
    "totalUsers": "Usuarios totales",
    "totalClients": "Clientes totales",
    "totalReferrals": "Referidos totales",
    "acrossAllCompanies": "En todas las empresas",
    "platformRevenue": "Ingresos de plataforma",
    "estimatedRevenue": "Estimado por referidos",
    "companiesOverview": "Resumen de empresas",
    "viewAll": "Ver todo",
    "noCompanies": "Aún no hay empresas registradas",
    "noCompaniesDesc": "Las empresas aparecerán aquí cuando se registren en la plataforma.",
    "systemPulse": "Pulso del sistema",
    "totalProspects": "Prospectos totales",
    "pendingGifts": "Regalos pendientes",
    "companyAdmins": "Admins de empresa",
    "manageAllSettings": "Gestionar toda la configuración",
    "clientsShort": "clientes",
    "vendorsShort": "representantes",
    "referralsShort": "referidos",
    "prospectsShort": "prospectos",
    "sidebarCompanies": "Empresas",
    "sidebarClients": "Clientes",
    "sidebarSales": "Ventas",
    "dashboardTitle": "Centro de control de plataforma",
    "dashboardSubtitle": "Supervise todo lo que ocurre en el sistema.",
    "companiesTitle": "Empresas",
    "companiesSubtitle": "Administre e inspeccione cada tenant de la plataforma.",
    "usersTitle": "Todos los usuarios",
    "usersSubtitle": "Explore admins, representantes y clientes de todas las empresas.",
    "clientsTitle": "Todos los clientes",
    "clientsSubtitle": "Vea cada cuenta de cliente registrada en el sistema.",
    "analyticsTitle": "Ventas y analítica",
    "analyticsSubtitle": "Rendimiento, ingresos y métricas de referidos a nivel plataforma.",
    "settingsTitle": "Configuración de plataforma",
    "settingsSubtitle": "Configure cuentas, empresas, recompensas, pipeline y valores por defecto.",
    "prospectsTitle": "Todos los prospectos",
    "prospectsSubtitle": "Actividad del pipeline en cada empresa.",
    "rewardsTitle": "Catálogo de recompensas",
    "rewardsSubtitle": "Gestione programas de recompensas por empresa.",
    "pendingGiftsTitle": "Regalos pendientes",
    "pendingGiftsSubtitle": "Seguimiento de reclamos de regalos en espera.",
    "vendorReviewsTitle": "Reseñas de representantes",
    "vendorReviewsSubtitle": "Opiniones de clientes en toda la plataforma.",
    "videoHubTitle": "Hub de videos",
    "videoHubSubtitle": "Elija una empresa para gestionar los videos que verán sus miembros y representantes.",
    "failedToLoadOverview": "Error al cargar el resumen de plataforma",
    "overviewLoadError": "No se pudieron cargar los datos de la plataforma. Verifique su conexión e intente de nuevo.",
    "retry": "Reintentar",
    "viewPendingGifts": "Revisar regalos pendientes",
    "notificationsComingSoon": "Las preferencias de notificación llegarán pronto",
    "notificationsComingSoonDesc": "Los controles de notificación a nivel plataforma estarán disponibles en una actualización futura. Use el centro de notificaciones en la barra superior por ahora.",
    "noRecentClients": "Aún no hay clientes registrados en esta empresa",
    "searchCompanies": "Buscar empresas...",
    "searchUsers": "Buscar usuarios por nombre, correo, empresa o teléfono...",
    "allCompanies": "Todas las empresas",
    "company": "Empresa",
    "admins": "Admins",
    "actions": "Acciones",
    "configure": "Configurar",
    "platformLevel": "Plataforma",
    "settingsHub": "Centro de configuración",
    "companiesSettings": "Empresas",
    "companiesSettingsDesc": "Revise la salud de cada tenant y entre a la configuración por empresa.",
    "rewardsSettings": "Recompensas y puntos",
    "rewardsSettingsDesc": "Edite reglas de puntos, catálogo, plazos de entrega y acciones rápidas.",
    "pipelineSettings": "Pipeline y estados",
    "pipelineSettingsDesc": "Gestione estados del pipeline de prospectos por empresa.",
    "operationsSettings": "Operaciones",
    "operationsSettingsDesc": "Resumen de áreas operativas que puede monitorear desde el menú.",
    "operationsImports": "Importación de usuarios",
    "operationsImportsDesc": "Importe representantes y clientes por empresa desde el portal de admin.",
    "operationsGifts": "Entrega de regalos",
    "operationsGiftsDesc": "Supervise regalos pendientes y entregas a nivel global.",
    "operationsReviews": "Reseñas de representantes",
    "operationsReviewsDesc": "Audite la satisfacción del cliente tras la entrega.",
    "operationsAnalytics": "Analítica de ventas",
    "operationsAnalyticsDesc": "Revise ingresos, referidos y conversiones en toda la plataforma.",
    "platformDefaults": "Valores de plataforma",
    "platformDefaultsDesc": "Controles globales reservados al super administrador.",
    "globalControlCenter": "Centro de control global",
    "globalControlCenterDesc": "Use el menú lateral para inspeccionar empresas, usuarios, ventas, prospectos, recompensas y entregas.",
    "accountSettingsDesc": "Actualice las credenciales de su cuenta super admin.",
    "profileSettingsDesc": "Su identidad como administrador de plataforma.",
    "selectCompanyContext": "Seleccione la empresa a configurar",
    "chooseCompany": "Elija una empresa...",
    "companyContextHint": "La configuración por empresa aplica solo al tenant seleccionado.",
    "pickCompanyFirst": "Seleccione una empresa arriba para editar su configuración.",
    "elevateRewardsUnavailable":
      "Elevate Hispano no usa recompensas, regalos ni reseñas de vendedor. Use Pipeline y estados para configurar esta empresa.",
    "elevateGiftsUnavailable": "Los regalos no forman parte del producto de Elevate Hispano.",
    "elevateReviewsUnavailable": "Las reseñas de regalos no forman parte del producto de Elevate Hispano.",
    "contextLabel": "Alcance de plataforma",
    "allCompaniesContext": "Todas las empresas",
    "allCompaniesContextHint": "Mostrando datos agregados de toda la plataforma.",
    "clearContext": "Limpiar filtro",
    "viewCompanyDetail": "Ver detalle de empresa",
    "viewCompanyUsers": "Ver usuarios",
    "configureCompany": "Configurar empresa",
    "viewAllUsers": "Ver todos los usuarios",
    "systemAlerts": "Alertas del sistema",
    "alertPendingGifts": "{count} regalo(s) pendiente(s) requieren atención",
    "alertNoClients": "Esta empresa aún no tiene clientes",
    "topPerformingCompanies": "Empresas con mejor rendimiento",
    "recentActivity": "Registros recientes",
    "noRecentActivity": "Aún no hay actividad reciente",
    "adminUserType": "Admin de empresa",
    "vendorUserType": "Representante",
    "clientUserType": "Cliente",
    "clientState": "Estado del cliente",
    "rewardPoints": "Puntos de recompensa",
    "sortBy": "Ordenar por",
    "companyDetailTitle": "Detalle de empresa",
    "companyDetailSubtitle": "Análisis profundo de salud, usuarios y actividad del tenant.",
    "companyComparison": "Comparación de empresas",
    "clientStateBreakdown": "Distribución de estados de clientes",
    "companyScopedAnalytics": "Filtrado por empresa seleccionada",
    "failedToLoadAnalytics": "Error al cargar analítica",
    "failedToLoadCompany": "Error al cargar detalle de empresa",
    "companyNotFound": "Empresa no encontrada",
    "companyNotFoundDesc": "La empresa seleccionada pudo haber sido eliminada o no está disponible.",
    "backToCompanies": "Volver a empresas",
    "registeredOn": "Registrado el",
    "viewCompanyProspects": "Ver prospectos",
    "topVendors": "Mejores representantes",
    "topClients": "Mejores clientes",
    "recentProspects": "Prospectos recientes",
    "recentClients": "Clientes recientes",
    "client": "Cliente",
    "noCompanyAdmins": "Sin admins de empresa asignados",
    "noVendorsYet": "Aún no hay representantes",
    "noActiveClientsYet": "Aún no hay clientes activos",
    "noProspectsYet": "Aún no hay prospectos",
    "revenue": "Ingresos",
    "viewDetails": "Ver detalles",
    "openSection": "Abrir sección",
    "allUsers": "Todos los usuarios de la plataforma",
    "backupsTitle": "Respaldos",
    "backupsSubtitle": "Descargue una copia completa de todas las tablas y restáurela si los datos de producción se llegan a perder.",
    "backups": {
      "heroTitle": "Respaldos completos de la plataforma",
      "heroDescription": "Cree una copia completa y portátil de todas las empresas, usuarios y registros de la plataforma, y restáurela desde esta misma pantalla cuando necesite recuperar la información.",
      "formatNote": "Formato: archivo ZIP con una copia JSON de todas las tablas más sus archivos cargados (avatares, imágenes de recompensas y videos).",
      "statTables": "Tablas",
      "statRows": "Filas de datos",
      "statFiles": "Archivos almacenados",
      "statFileSize": "Almacenamiento de archivos",
      "inventorySummary": "El respaldo incluirá {rows} filas y {files} archivos cargados.",
      "downloadTitle": "Descargar respaldo",
      "downloadDescription": "Guarde una copia completa de la plataforma en su computadora.",
      "includeFiles": "Incluir archivos cargados",
      "includeFilesHint": "Agrega avatares, imágenes de recompensas y videos. Desactívelo para un respaldo más liviano, solo de datos.",
      "downloadButton": "Descargar respaldo",
      "downloading": "Preparando respaldo...",
      "downloadSuccess": "Respaldo descargado",
      "downloadError": "No se pudo generar el respaldo",
      "restoreTitle": "Restaurar desde respaldo",
      "restoreDescription": "Suba un archivo de respaldo creado en esta pantalla para recuperar la plataforma.",
      "warningTitle": "Esto reemplaza todos los datos actuales",
      "warningText": "Todas las tablas de la base de datos se sobrescribirán con el contenido del respaldo. Esta acción no se puede deshacer, así que asegúrese de descargar un respaldo nuevo antes de continuar.",
      "chooseFile": "Archivo de respaldo (.zip)",
      "noFileSelected": "Aún no ha seleccionado un archivo.",
      "confirmLabel": "Escriba RESTORE para confirmar",
      "restoreButton": "Restaurar respaldo",
      "restoring": "Restaurando...",
      "restoreConfirmTitle": "¿Restaurar este respaldo?",
      "restoreConfirmMessage": "Todos los datos actuales serán reemplazados por el contenido del archivo seleccionado. Esta acción no se puede deshacer.",
      "restoreConfirmAction": "Sí, restaurar",
      "restoreSuccess": "Respaldo restaurado",
      "restoreError": "La restauración falló",
      "restoreResultTitle": "Restauración completada",
      "restoreResultDescription": "Los datos de su archivo de respaldo ya están activos.",
      "restoreResultTables": "Tablas restauradas",
      "restoreResultFiles": "Archivos restaurados",
      "restoreResultSource": "Respaldo creado",
      "reload": "Recargar página",
      "loadError": "No se pudo cargar el inventario de respaldos",
      "retry": "Reintentar"
    }
  },
  "sidebar": {
    "dashboard": "Panel",
    "byCompany": "Por {company}",
    "analytics": "Analítica",
    "referrals": "Referidos",
    "network": "Red",
    "rewards": "Recompensas",
    "users": "Usuarios",
    "importUsers": "Importar usuarios",
    "myClients": "Miembros",
    "prospects": "Prospectos",
    "partners": "Red de socios",
    "pendingGifts": "Regalos pendientes",
    "giftsInTransit": "Regalos en camino",
    "myContacts": "Mis contactos",
    "vendorReviews": "Reseñas de Representantes",
    "videoHub": "Hub de videos",
    "backups": "Respaldos",
    "settings": "Configuración",
    "promotions": "Promociones",
    "logout": "Cerrar sesión"
  },
  "promotions": {
    "eyebrow": "Rifas y premios",
    "title": "Promociones",
    "subtitle": "Refiere personas nuevas y gana tickets para las rifas activas de Elevate Hispano.",
    "activeNow": "Rifa activa",
    "startsOn": "Comienza {date}",
    "endsOn": "Cierra {date}",
    "drawOn": "Sorteo {date}",
    "requiredLabel": "{count} referidos",
    "progressText": "{current} de {required} referidos",
    "remainingOne": "Te falta 1 referido para tu ticket",
    "remainingMany": "Te faltan {count} referidos para tu ticket",
    "qualified": "¡Ya estás participando! Tu ticket está activo.",
    "inviteCta": "Invitar ahora",
    "viewReferrals": "Ver mis enlaces",
    "myTickets": "Mis tickets",
    "myTicketsSubtitle": "Cada ticket representa una participación en una rifa.",
    "noTickets": "Aún no tienes tickets",
    "noTicketsDescription": "Alcanza la meta de referidos de una rifa activa y tu ticket aparecerá aquí.",
    "ticketCode": "Ticket",
    "cycleLabel": "Periodo",
    "wonPrize": "Ganaste {prize}",
    "winners": "Ganadores",
    "winnersSubtitle": "Estos son los ganadores de los sorteos recientes.",
    "youWon": "¡Ganaste!",
    "statusActive": "En juego",
    "statusWon": "Ganador",
    "statusLost": "No ganó",
    "noPromotions": "No hay promociones activas",
    "noPromotionsDescription": "Vuelve pronto: aquí verás las rifas disponibles.",
    "loadError": "No se pudieron cargar las promociones",
    "prizeCash": "Efectivo",
    "prizePhysical": "Premio",
    "pastCycles": "Historial de sorteos",
    "adminTitle": "Promociones",
    "adminSubtitle": "Gestiona campañas de rifas, periodos y ganadores.",
    "newPromotion": "Nueva promoción",
    "editPromotion": "Editar promoción",
    "statPromotions": "Promociones",
    "statActive": "Activas",
    "statTickets": "Tickets",
    "statWinners": "Ganadores",
    "active": "Activa",
    "inactive": "Inactiva",
    "referralsShort": "refs",
    "partnersShort": "socios",
    "ticketsShort": "tickets",
    "edit": "Editar",
    "delete": "Eliminar",
    "addCycle": "Agregar periodo",
    "participants": "Participantes",
    "setWinner": "Fijar ganador",
    "draw": "Sortear",
    "drawn": "Ganador sorteado",
    "open": "Abierto",
    "scheduled": "Programado",
    "drawnLabel": "Sorteado",
    "due": "Pendiente de sorteo",
    "auditTitle": "Auditoría de sorteos",
    "override": "Ganador manual",
    "fieldTitle": "Título",
    "fieldPrize": "Nombre del premio",
    "fieldPrizeType": "Tipo de premio",
    "fieldRequired": "Referidos requeridos",
    "fieldMinState": "Estado mínimo del referido",
    "fieldValue": "Valor del premio (centavos)",
    "fieldSubtitle": "Subtítulo",
    "fieldDescription": "Descripción",
    "fieldImage": "Imagen del premio",
    "countPartners": "Contar socios",
    "exclusive": "Exclusiva",
    "exclusiveClient": "Cliente exclusivo (correo)",
    "exclusiveClientHint": "Déjalo vacío para que todos los clientes la vean y participen.",
    "cycleModalTitle": "Periodo",
    "fieldLabel": "Etiqueta",
    "fieldStart": "Inicio",
    "fieldEnd": "Fin",
    "fieldDraw": "Fecha de sorteo",
    "fieldDrawHint": "Si se deja vacío, se sortea al finalizar el periodo.",
    "noParticipants": "Aún no hay tickets.",
    "winner": "Ganador",
    "reason": "Motivo",
    "reasonRequired": "Selecciona un ganador e indica un motivo",
    "requiredFields": "Título y nombre del premio son obligatorios",
    "datesRequired": "Inicio y fin son obligatorios",
    "saved": "Guardado",
    "saveError": "No se pudo guardar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "deleted": "Eliminado",
    "deleteTitle": "Eliminar promoción",
    "deleteMessage": "¿Eliminar \"{title}\"? Esta acción no se puede deshacer.",
    "deleteCycleTitle": "Eliminar periodo",
    "deleteCycleMessage": "¿Eliminar el periodo \"{label}\"?",
    "drawTitle": "Sortear ahora",
    "drawMessage": "¿Sortear un ganador para \"{label}\" ahora? No se puede deshacer."
  },
  "promotionsIntro": {
    "eyebrow": "Rifas y premios",
    "title": "¡Ya puedes ganar premios!",
    "subtitle": "Refiere personas nuevas y participa en las rifas de Elevate Hispano.",
    "required": "{count} referidos",
    "viewCta": "Ver promociones",
    "dismiss": "Quizás después"
  },
  "videoHub": {
    "eyebrow": "Aprende",
    "title": "Hub de videos",
    "clientSubtitle": "Mira capacitaciones, producto y novedades preparadas para los miembros de tu organización.",
    "vendorSubtitle": "Mira playbooks y videos de empresa preparados para los representantes de tu organización.",
    "nowPlaying": "Destacado",
    "watchNow": "Ver ahora",
    "searchPlaceholder": "Buscar videos...",
    "allCategories": "Todos",
    "featured": "Destacado",
    "emptyTitle": "Aún no hay videos",
    "emptyDescription": "Tu empresa todavía no publicó videos en este hub. Vuelve pronto.",
    "noResultsTitle": "Sin coincidencias",
    "noResultsDescription": "Prueba con otra búsqueda o categoría.",
    "relatedLinks": "Enlaces relacionados",
    "videoUnavailable": "Ese video ya no está disponible en tu hub.",
    "loadError": "No se pudieron cargar los videos",
    "categories": {
      "general": "General",
      "onboarding": "Bienvenida",
      "training": "Capacitación",
      "product": "Producto",
      "announcements": "Novedades"
    },
    "adminEyebrow": "Biblioteca de la empresa",
    "adminTitle": "Hub de videos",
    "adminSubtitle": "Sube archivos o pega una URL. La visibilidad aplica solo a miembros y representantes de esta empresa.",
    "addVideo": "Agregar video",
    "editVideo": "Editar video",
    "createVideo": "Publicar video",
    "saveChanges": "Guardar cambios",
    "companyContext": "Empresa",
    "chooseCompany": "Elija una empresa...",
    "companyHint": "Cada empresa tiene su propia biblioteca privada. Los videos no se mezclan entre tenants.",
    "pickCompanyTitle": "Seleccione una empresa",
    "pickCompanyDescription": "Use Alcance de plataforma arriba para elegir una empresa. El Hub de videos se gestiona por tenant.",
    "statTotal": "Videos",
    "statPublished": "Publicados",
    "statClients": "Para miembros",
    "statVendors": "Para representantes",
    "adminEmptyTitle": "Arma la biblioteca de la empresa",
    "adminEmptyDescription": "Agrega un enlace de YouTube/Vimeo o sube un MP4. Elige si lo ven miembros, representantes o ambos.",
    "draft": "Borrador",
    "sourceUrl": "URL",
    "sourceFile": "Archivo",
    "preview": "Vista previa",
    "edit": "Editar",
    "delete": "Eliminar",
    "fieldTitle": "Título",
    "fieldDescription": "Descripción",
    "fieldCategory": "Categoría",
    "fieldSortOrder": "Posición en la lista",
    "sortHint": "Los destacados siguen abriendo el foco de arriba. Esto solo ordena el resto del hub.",
    "sortFirst": "Primero en la lista",
    "sortHigh": "Cerca del inicio",
    "sortNormal": "Orden normal",
    "sortLast": "Al final de la lista",
    "sortCustom": "Posición personalizada",
    "fieldSource": "Origen",
    "fieldUrl": "URL del video",
    "urlHint": "YouTube, Vimeo o un enlace directo MP4/WEBM.",
    "fieldFile": "Archivo de video",
    "chooseFile": "Elegir archivo de video",
    "fileHint": "MP4, WEBM, MOV, OGG o M4V. Máximo 200 MB. Se guarda en /uploads/videos/<company_id>/.",
    "fieldAudience": "Quién puede verlo",
    "audienceClients": "Miembros",
    "audienceClientsHint": "Solo los miembros de esta empresa pueden verlo.",
    "audienceVendors": "Representantes",
    "audienceVendorsHint": "Solo los representantes de esta empresa pueden verlo.",
    "audienceBoth": "Miembros y representantes",
    "audienceAll": "Todos",
    "audienceHintAll": "Lo ven miembros y representantes de esta empresa.",
    "audienceRequired": "Seleccione al menos una audiencia",
    "fieldListing": "Cómo se muestra",
    "published": "Publicado",
    "publishedHint": "Visible en la lista del hub para la audiencia elegida.",
    "featuredHint": "Queda fijado en el foco de la parte superior del hub.",
    "draftHint": "Oculto en el hub hasta que lo publiques.",
    "fieldThumbnail": "URL de miniatura",
    "uploadThumbnail": "O sube una imagen de miniatura",
    "fieldLinks": "Enlaces relacionados",
    "linkLabel": "Etiqueta",
    "addLink": "Agregar enlace",
    "removeLink": "Quitar",
    "titleRequired": "El título es obligatorio",
    "urlRequired": "Pega una URL o cambia a subida de archivo",
    "created": "Video creado",
    "updated": "Video actualizado",
    "deleted": "Video eliminado",
    "saveError": "No se pudo guardar el video",
    "deleteTitle": "¿Eliminar este video?",
    "deleteMessage": "“{title}” se quitará del hub de esta empresa. Los archivos subidos se borran del disco.",
    "deleteConfirm": "Eliminar video"
  },
  "topBar": {
    "settings": "Configuración",
    "signOut": "Cerrar sesión",
    "useLightTheme": "Usar tema claro",
    "useDarkTheme": "Usar tema oscuro",
    "pointsBalance": "Saldo de puntos: {count}",
    "notifications": "Notificaciones",
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú"
  },
  "settings": {
    "title": "Configuración",
    "subtitle": "Gestione su cuenta y preferencias",
    "systemSettings": "Configuración del sistema",
    "profile": "Perfil",
    "notifications": "Notificaciones",
    "privacy": "Privacidad",
    "appearance": "Apariencia e idioma",
    "updateAccount": "Actualice el nombre y la contraseña de su cuenta",
    "name": "Nombre",
    "yourName": "Su nombre",
    "changePassword": "Cambiar contraseña",
    "leaveEmpty": "Deje los campos de contraseña vacíos si no desea cambiarla",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "confirmNewPassword": "Confirmar nueva contraseña",
    "enterCurrentPassword": "Ingrese la contraseña actual",
    "enterNewPassword": "Ingrese la nueva contraseña",
    "confirmNewPasswordPlaceholder": "Confirmar nueva contraseña",
    "saveChanges": "Guardar cambios",
    "personalInfo": "Información personal",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "bio": "Biografía",
    "tellUs": "Cuéntenos sobre usted...",
    "saveProfile": "Guardar cambios",
    "profilePhoto": "Foto de perfil",
    "uploadPhoto": "Subir foto",
    "uploadingPhoto": "Subiendo...",
    "removePhoto": "Quitar foto",
    "avatarHint": "Las imágenes cuadradas se ven mejor. Su foto aparece en el menú lateral.",
    "avatarUploaded": "Foto de perfil actualizada.",
    "avatarRemoved": "Foto de perfil eliminada.",
    "avatarUploadFailed": "No se pudo actualizar la foto de perfil.",
    "avatarInvalidType": "Seleccione una imagen válida (PNG, JPG, WEBP o GIF).",
    "avatarTooLarge": "La imagen es demasiado grande. Tamaño máximo: 5 MB.",
    "notificationPreferences": "Preferencias de notificaciones",
    "emailNotifications": "Notificaciones por correo",
    "emailNotificationsDesc": "Recibir notificaciones por correo",
    "pushNotifications": "Notificaciones push",
    "pushNotificationsDesc": "Notificaciones en tiempo real",
    "weeklyReports": "Informes semanales",
    "weeklyReportsDesc": "Resumen de actividad semanal",
    "newReferrals": "Nuevos referidos",
    "newReferralsDesc": "Cuando alguien usa su código",
    "conversions": "Conversiones",
    "conversionsDesc": "Cuando se completa una conversión",
    "savePreferences": "Guardar preferencias",
    "privacySettings": "Configuración de privacidad",
    "publicProfile": "Perfil público",
    "publicProfileDesc": "Haga visible su perfil para otros usuarios",
    "showStats": "Mostrar estadísticas",
    "showStatsDesc": "Mostrar sus estadísticas públicamente",
    "allowMessages": "Permitir mensajes",
    "allowMessagesDesc": "Permitir que otros le envíen mensajes",
    "dataSharing": "Compartir datos",
    "dataSharingDesc": "Compartir datos anónimos para mejorar el servicio",
    "optOutRight": "Derecho de Exclusión (Opt-out)",
    "optOutRightDesc": "Ejercer su derecho para que no vendamos ni compartamos su información personal con terceros",
    "savePrivacy": "Guardar configuración",
    "appearanceLocalization": "Apariencia e idioma",
    "theme": "Tema",
    "light": "Claro",
    "dark": "Oscuro",
    "auto": "Automático",
    "language": "Idioma",
    "languageEn": "Inglés",
    "languageEs": "Español",
    "languageChanged": "Idioma actualizado",
    "timezone": "Zona horaria",
    "dateFormat": "Formato de fecha",
    "saveAppearance": "Guardar preferencias",
    "confirmChanges": "Confirmar cambios",
    "confirmChangesDesc": "¿Está seguro de que desea actualizar su configuración con los siguientes cambios?",
    "updating": "Actualizando...",
    "nameRequired": "El nombre es obligatorio",
    "currentPasswordRequired": "Se requiere la contraseña actual para cambiarla",
    "passwordsNoMatch": "Las contraseñas nuevas no coinciden",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
    "settingsUpdated": "¡Configuración actualizada correctamente!",
    "failedUpdate": "No se pudo actualizar la configuración",
    "errorUpdating": "Ocurrió un error al actualizar la configuración",
    "savedSuccessfully": "guardado correctamente",
    "platformConfig": "Configuración del sistema",
    "platformConfigDesc": "Gestione estados del pipeline, tipos de venta y otros valores preconfigurados.",
    "systemConfig": {
      "prospectStatusesTitle": "Estados de prospecto",
      "prospectStatusesDesc": "Administre las etapas del pipeline. Los prospectos nuevos usan el estado predeterminado.",
      "saleTypesTitle": "Tipos de venta",
      "saleTypesDesc": "Opciones mostradas cuando un prospecto llega a etapa de venta.",
      "addStatus": "Agregar estado",
      "addSaleType": "Agregar tipo de venta",
      "code": "Código",
      "label": "Etiqueta",
      "labelPlaceholder": "Nombre visible",
      "sortOrder": "Orden",
      "badgeTone": "Color de insignia",
      "setAsDefault": "Establecer como estado predeterminado para nuevos prospectos",
      "active": "Activo",
      "defaultBadge": "Predeterminado",
      "inactiveBadge": "Inactivo",
      "save": "Guardar",
      "cancel": "Cancelar",
      "edit": "Editar",
      "delete": "Eliminar",
      "loading": "Cargando…",
      "saved": "Guardado",
      "deleted": "Eliminado",
      "labelRequired": "La etiqueta es obligatoria",
      "failedToLoad": "No se pudo cargar la configuración del sistema",
      "failedToLoadCompanies": "No se pudieron cargar las empresas",
      "companyLabel": "Empresa",
      "failedToSave": "No se pudo guardar",
      "failedToDelete": "No se pudo eliminar",
      "confirmDeleteStatus": "¿Eliminar el estado \"{name}\"?",
      "confirmDeleteSaleType": "¿Eliminar el tipo de venta \"{name}\"?"
    }
  },
  "referral": {
    "loading": "Cargando...",
    "welcome": "¡Bienvenido!",
    "referredBy": "Usted fue referido por",
    "joinNow": "Unirse ahora",
    "alreadyHaveAccount": "¿Ya tiene una cuenta?",
    "signIn": "Iniciar sesión",
    "register": "Registrarse",
    "createAccount": "Crear cuenta",
    "exclusiveRewards": "Recompensas exclusivas",
    "exclusiveRewardsDesc": "Obtenga beneficios únicos por cada referido",
    "premiumProgram": "Programa premium",
    "premiumProgramDesc": "Acceda a funciones avanzadas del sistema",
    "activeCommunity": "Comunidad activa",
    "activeCommunityDesc": "Únase a una red de usuarios comprometidos",
    "registrationSuccessful": "¡Registro exitoso! ¡Bienvenido a nuestra plataforma!",
    "accountCreatedSuccess": "Cuenta creada con éxito",
    "registrationFailed": "Error en el registro",
    "errorOccurred": "Ocurrió un error durante el registro",
    "passwordsDoNotMatch": "Las contraseñas no coinciden",
    "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
    "invalidReferralLink": "Enlace de referido no válido",
    "createYourAccount": "Cree su cuenta",
    "referredByLine": "Referido por {name}",
    "chooseUsername": "Elija un nombre de usuario",
    "emailPlaceholder": "su.correo@ejemplo.com",
    "phonePlaceholder": "(555) 555-0123",
    "phoneInvalid": "Ingrese un número de teléfono válido de 10 dígitos (EE.UU.)",
    "passwordMinPlaceholder": "Al menos 6 caracteres",
    "confirmPasswordPlaceholder": "Vuelva a ingresar su contraseña",
    "invitedByLine": "Has sido invitado por {name}",
    "joinProgramToday": "Únete a nuestro programa de referidos y empieza a ganar hoy",
    "whatAwaitsYou": "¿Qué te espera?",
    "discoverBenefits": "Descubre los beneficios de nuestro programa",
    "goToHome": "Ir al inicio",
    "username": "Nombre de usuario",
    "email": "Correo electrónico",
    "phone": "Teléfono",
    "dateOfBirth": "Fecha de nacimiento",
    "dateOfBirthPlaceholder": "Seleccione su fecha de nacimiento",
    "dateOfBirthRequired": "La fecha de nacimiento es obligatoria",
    "calendarPrevMonth": "Mes anterior",
    "calendarNextMonth": "Mes siguiente",
    "calendarClose": "Cerrar calendario",
    "calendarSelectMonthYear": "Elegir mes y año",
    "calendarWeekdays": {
      "sun": "Dom",
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mié",
      "thu": "Jue",
      "fri": "Vie",
      "sat": "Sáb"
    },
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "registering": "Creando cuenta...",
    "back": "Volver",
    "registrationSuccessTitle": "¡Registro exitoso!",
    "registrationSuccessMessage": "Gracias por unirte a nuestro programa. Tu referidor ha sido notificado.",
    "referralProgram": "Programa de referidos",
    "linkGeneratedBy": "Este enlace fue generado por nuestro sistema de referidos",
    "brandName": "Enrola",
    "joinPartnerProgramToday": "Únete al programa de socios y empieza a crear tu red de ventas hoy",
    "partnerWhatAwaitsYou": "¿Qué te ofrece el programa de socios?",
    "partnerRewards": "Ingresos por referidos",
    "partnerRewardsDesc": "Gana recompensas por cada socio que se incorpore",
    "partnerGrowth": "Herramientas de venta",
    "partnerGrowthDesc": "Accede a herramientas para hacer crecer tu negocio",
    "partnerNetwork": "Red de socios",
    "partnerNetworkDesc": "Conecta con otros vendedores de la empresa",
    "partnerVideoTitle": "Video del programa de socios",
    "programVideoTitle": "Video del programa",
    "continueWithRegistration": "Continuar con el registro",
    "partnerSubmit": "Enviar solicitud",
    "partnerRequestReceived": "Solicitud enviada",
    "partnerRequestReceivedTitle": "¡Solicitud recibida!",
    "partnerRequestReceivedMessage": "Tu solicitud para el programa de socios fue enviada. El líder de tu programa revisará tu información y te contactará. Recibirás un correo cuando avances de etapa.",
    "dateOfBirthOptional": "Fecha de nacimiento (opcional)"
  },
  "notifications": {
    "title": "Notificaciones",
    "all": "Todos",
    "unread": "Sin leer",
    "success": "Éxito",
    "info": "Información",
    "markAllRead": "Marcar todo como leído",
    "markAsRead": "Marcar como leído",
    "delete": "Eliminar",
    "loading": "Cargando notificaciones...",
    "noNotifications": "Sin notificaciones",
    "noNotificationsDescription": "Estás al día. Las nuevas alertas aparecerán aquí.",
    "failedToLoad": "No se pudieron cargar las notificaciones",
    "failedToMarkRead": "No se pudo marcar la notificación como leída",
    "failedToMarkAllRead": "No se pudieron marcar todas las notificaciones como leídas",
    "failedToUpdate": "No se pudo actualizar la notificación",
    "allMarkedRead": "Todas las notificaciones marcadas como leídas",
    "failedToUpdateAll": "No se pudieron actualizar las notificaciones",
    "deleted": "Notificación eliminada",
    "failedToDelete": "No se pudo eliminar la notificación",
    "viewDetails": "Toca para ver",
    "fallbacks": {
      "unknownVendor": "Un representante",
      "unknownClient": "Un cliente",
      "unknownProspect": "Un prospecto",
      "unknownMember": "Un miembro",
      "unknownReward": "Un regalo",
      "unknownVideo": "Un video",
      "theirVendor": "su representante"
    },
    "messages": {
      "promotionTicketEarned": {
        "title": "¡Ganaste un ticket!",
        "message": "Alcanzaste {required} referidos en {promotionTitle} ({cycleLabel}). Tu ticket está participando."
      },
      "promotionWinner": {
        "title": "¡Ganaste la rifa!",
        "message": "¡Felicidades! Ganaste {prizeName} en {promotionTitle}."
      },
      "clientReferralGenerated": {
        "title": "El cliente generó un referido",
        "message": "{referrer} refirió a {newClient}."
      },
      "pointsEarnedReferral": {
        "title": "¡Puntos ganados!",
        "message": "¡Ganaste {points} puntos! {newClient} se unió con tu referido."
      },
      "newReferral": {
        "title": "Nuevo referido",
        "message": "{newClient} se unió usando tu código de referido."
      },
      "newRewardCatalog": {
        "title": "Nuevo regalo en el catálogo",
        "message": "{rewardName} ya está disponible ({points} puntos)."
      },
      "newVideoPublished": {
        "title": "Nuevo video en el hub",
        "message": "{videoTitle} ya está disponible en el Hub de videos."
      },
      "giftOnTheWay": {
        "title": "Regalo en camino",
        "message": "Tu {rewardName} fue entregado a {vendorName} y pronto te lo enviará."
      },
      "prospectEnrolled": {
        "title": "Prospecto inscrito",
        "message": "{vendorName} inscribió a {clientName} como nuevo cliente."
      },
      "newProspect": {
        "title": "Nuevo prospecto",
        "message": "{vendorName} agregó el prospecto {prospectName}."
      },
      "prospectsImportedOne": {
        "title": "Prospectos importados",
        "message": "{vendorName} importó 1 prospecto."
      },
      "prospectsImportedMany": {
        "title": "Prospectos importados",
        "message": "{vendorName} importó {count} prospectos."
      },
      "newAffiliation": {
        "title": "Nueva afiliación",
        "message": "{username} se unió a la plataforma."
      },
      "clientProgressUpdatedAdmin": {
        "title": "Progreso del cliente actualizado",
        "message": "{username} avanzó a {state}."
      },
      "newReferralInNetwork": {
        "title": "Nuevo referido en la red",
        "message": "{referrer} refirió a {newClient}."
      },
      "newReferralSignup": {
        "title": "Nuevo registro por referido",
        "message": "{username} se registró usando tu enlace de referido."
      },
      "newPartnerProspect": {
        "title": "Nuevo prospecto de socio",
        "message": "{prospectName} se registró en tu programa de socios."
      },
      "newPartnerProspectAdmin": {
        "title": "Nuevo prospecto de socio",
        "message": "{prospectName} se registró en el programa de socios."
      },
      "partnerProspectStatus": {
        "title": "Prospecto de socio actualizado",
        "message": "{prospectName} avanzó a {status}."
      },
      "partnerProspectStatusAdmin": {
        "title": "Prospecto de socio actualizado",
        "message": "{prospectName} avanzó a {status}."
      },
      "partnerEnrolled": {
        "title": "Socio enrolado",
        "message": "{partnerName} fue enrolado como socio."
      },
      "partnerEnrolledLeader": {
        "title": "Socio enrolado",
        "message": "{partnerName} ya forma parte de tu red de socios."
      },
      "welcomeBonus": {
        "title": "¡Bono de bienvenida!",
        "message": "Recibiste {points} puntos de bienvenida. ¡Empieza a explorar tus recompensas!"
      },
      "pointsEarnedStateAdvance": {
        "title": "¡Puntos ganados!",
        "message": "¡Ganaste {points} puntos! {username} avanzó a {state}."
      },
      "clientReferralProgress": {
        "title": "Progreso de referido del cliente",
        "message": "{referrer} ganó puntos porque {username} avanzó a {state}."
      },
      "clientProgressUpdatedVendor": {
        "title": "Progreso del cliente actualizado",
        "message": "{username} pasó de {fromState} a {toState}."
      },
      "statusUpdated": {
        "title": "Estado actualizado",
        "message": "Tu estado se actualizó a {state}."
      },
      "newRewardClaimVendor": {
        "title": "Nuevo canje de regalo",
        "message": "{clientName} canjeó {rewardName}. Prepáralo para entregar a tu cliente."
      },
      "rewardClaimPendingAdmin": {
        "title": "Canje de regalo pendiente",
        "message": "{clientName} canjeó {rewardName}. Entrega el regalo a {vendorName}."
      },
      "giftReadyForVendorDelivery": {
        "title": "Regalo listo para entregar al cliente",
        "message": "{rewardName} para {clientName} está listo. Entrégalo a tu cliente."
      },
      "giftDelivered": {
        "title": "Regalo entregado",
        "message": "Tu {rewardName} fue entregado. ¡Disfrútalo!"
      },
      "shortActionPointsEarned": {
        "title": "¡Puntos extra ganados!",
        "message": "Ganaste {points} puntos extra por completar una acción rápida."
      },
      "shortActionInvite3Complete": {
        "title": "¡3 invitaciones hoy — bono desbloqueado!",
        "message": "Invitaste a 3 personas hoy y ganaste {points} puntos extra."
      }
    }
  },
  "admin": {
    "dashboard": "Panel",
    "users": "Usuarios",
    "analytics": "Analítica",
    "importUsers": "Importar usuarios",
    "rewards": "Recompensas",
    "totalUsers": "Usuarios totales",
    "activeUsers": "Usuarios activos",
    "totalReferrals": "Referidos totales",
    "conversionRate": "Tasa de conversión",
    "addUser": "Agregar usuario",
    "editUser": "Editar usuario",
    "deleteUser": "Eliminar usuario",
    "userDetails": "Detalles del usuario",
    "import": "Importar",
    "export": "Exportar",
    "filter": "Filtrar",
    "sort": "Ordenar",
    "searchUsers": "Buscar usuarios...",
    "all": "Todos",
    "clients": "clientes",
    "vendors": "Representantes",
    "vendorRole": "Representante",
    "admins": "Administradores",
    "adminControlCenter": "Centro de control de administración",
    "completeSystemOverview": "Vista completa del sistema y herramientas de gestión al alcance de su mano.",
    "systemAdministrator": "Administrador del sistema",
    "systemAnalytics": "Analítica del sistema",
    "userManagement": "Gestión de usuarios",
    "systemSettings": "Configuración del sistema",
    "notifications": "Notificaciones",
    "rewardsManagement": "Gestión de recompensas",
    "adminDashboard": "Panel de administración",
    "monitorSystemPerformance": "Supervise el rendimiento del sistema y las métricas de usuarios",
    "manageUsersDescription": "Gestione usuarios y sus actividades de referidos",
    "manageUsers": "Gestionar usuarios",
    "configureSystemSettings": "Configure ajustes y preferencias del sistema",
    "systemAlerts": "Alertas del sistema y actualizaciones importantes",
    "configureRewardPoints": "Configure puntos de recompensa y gestione el catálogo de recompensas",
    "welcomeBack": "¡Bienvenido de nuevo, {name}! Aquí tiene un resumen del sistema.",
    "totalRevenue": "Ingresos totales",
    "growthAnalytics": "Analítica de crecimiento",
    "advancedAnalytics": "Analítica avanzada e información para comprender el rendimiento de su programa de referidos",
    "activeReferrals": "Referidos activos",
    "activeReferrers": "Referidores activos",
    "totalPlatformRevenue": "Ingresos totales de la plataforma",
    "registeredPlatformUsers": "Usuarios registrados en la plataforma",
    "totalSuccessfulReferrals": "Referidos exitosos totales",
    "clientsMakingReferrals": "Clientes que refieren",
    "platformRevenue": "Ingresos de la plataforma",
    "allUsers": "Todos los usuarios",
    "platformReferrals": "Referidos de la plataforma",
    "recentUsers": "Usuarios recientes",
    "viewAllUsers": "Ver todos los usuarios",
    "userOverview": "Resumen de usuarios",
    "latestUserRegistrations": "Últimos registros de usuarios y actividad",
    "quickActions": "Acciones rápidas",
    "viewAnalytics": "Ver analítica",
    "rewardsSystem": "Sistema de recompensas",
    "platformStatistics": "Estadísticas de la plataforma",
    "totalVendors": "Representantes totales",
    "totalClients": "Clientes totales",
    "avgReferralsPerClient": "Prom. referidos/cliente",
    "activeReferralRate": "Tasa de referidos activos",
    "administrators": "Administradores",
    "searchByUsername": "Buscar por usuario, correo o teléfono...",
    "dateJoined": "Fecha de registro",
    "user": "Usuario",
    "type": "Tipo",
    "contact": "Contacto",
    "joined": "Registrado",
    "actions": "Acciones",
    "viewDetails": "Ver detalles",
    "clientStateDistribution": "Distribución por estado del cliente",
    "prospectStateDistribution": "Distribución por estado del prospecto",
    "completionRate": "Tasa de finalización",
    "affiliated": "Afiliado",
    "contacted": "Contactado",
    "visited": "Visitado",
    "completed": "Completado",
    "keyPerformanceIndicators": "Indicadores clave de rendimiento",
    "activeReferralLinks": "Enlaces de referidos activos",
    "totalClicks": "Clics totales",
    "topVendors": "Mejores Representantes",
    "topClients": "Mejores clientes",
    "noVendorsYet": "Aún no hay representantes",
    "noActiveClientsYet": "Aún no hay clientes activos",
    "revenueAnalytics": "Analítica de ingresos",
    "fromReferrals": "De {count} referidos",
    "revenuePerReferral": "Ingresos por referido",
    "standardCommission": "Comisión estándar",
    "revenuePerVendor": "Ingresos por Representante",
    "averageAcrossVendors": "Promedio entre {count} representantes",
    "importUsersFromExcel": "Importar usuarios desde Excel",
    "chooseImportType": "Elija el tipo de usuarios que desea importar y cargue un archivo Excel siguiendo la plantilla.",
    "importVendors": "Importar Representantes",
    "importClients": "Importar clientes",
    "downloadTemplate": "Descargar plantilla",
    "uploadFileToPreview": "Cargar archivo para vista previa",
    "selectVendor": "Seleccione representante para asignación de clientes",
    "selectAVendor": "Seleccione un representante...",
    "allImportedClientsAssigned": "Todos los clientes importados se asignarán al representante seleccionado.",
    "clientsLabel": "clientes",
    "noPhone": "Sin teléfono",
    "noUsersFound": "No se encontraron usuarios",
    "tryAdjustingFilters": "Intente ajustar sus filtros o el término de búsqueda.",
    "username": "Nombre de usuario",
    "vsLastPeriod": "vs. período anterior",
    "last7Days": "Últimos 7 días",
    "importFailed": "Error en la importación",
    "pleaseSelectVendor": "Seleccione un representante para la importación de clientes",
    "failedToLoadVendors": "No se pudieron cargar los representantes",
    "failedToDownloadTemplate": "No se pudo descargar la plantilla",
    "invalidServerResponse": "Respuesta inválida del servidor",
    "importPreviewErrors": "Vista previa: {valid} válidos, {invalid} con errores",
    "importPreviewReady": "Vista previa generada: {valid} registros listos para importar",
    "failedToParseExcel": "No se pudo analizar el archivo Excel",
    "importedCount": "Importados {count} {type}",
    "importedCountWithEmails": "Importados {count} {type}. Correos de acceso enviados: {emails}",
    "importPartialErrors": "{count} registros tuvieron errores",
    "errorLoadingUsers": "Error al cargar usuarios",
    "memberSince": "Miembro desde",
    "referredBy": "Referido por",
    "userDetailsComingSoon": "Funciones adicionales de gestión de usuarios estarán disponibles aquí.",
    "fullName": "Nombre completo",
    "email": "Correo",
    "phone": "Teléfono",
    "saveUserChanges": "Guardar cambios",
    "userUpdated": "Usuario actualizado",
    "userUpdatedAndNotified": "Usuario actualizado y notificado por correo",
    "userUpdateFailed": "No se pudo actualizar el usuario",
    "setTemporaryPassword": "Establecer contraseña temporal (opcional)",
    "leaveBlankToKeepPassword": "Déjalo vacío para mantener la contraseña actual",
    "temporaryPasswordHint": "Si la defines, el usuario recibirá la nueva contraseña por correo.",
    "resetPasswordSectionTitle": "Restablecer contraseña",
    "resetPasswordSectionHint": "Envía un enlace seguro para que el usuario elija una nueva contraseña.",
    "sendPasswordResetLink": "Enviar enlace de restablecimiento",
    "passwordResetLinkSent": "Enlace de restablecimiento enviado",
    "passwordResetQueued": "Restablecimiento solicitado",
    "passwordResetFailed": "No se pudo enviar el enlace de restablecimiento",
    "importPreviewTitle": "Vista previa de importación ({ready} listos, {errors} errores)",
    "importPreviewHint": "Solo se importarán los registros con estado \"listo\".",
    "searchImportPreview": "Buscar en la vista previa...",
    "filterImportStatus": "Estado de importación",
    "importColRow": "Fila",
    "importColReferredBy": "Referido por",
    "importStatusReady": "Listo",
    "cancelPreview": "Cancelar vista previa",
    "importRecords": "Importar {count} registros",
    "importModalTitle": "Importar {type} desde Excel",
    "importModalInstructions": "Cargue un archivo .xlsx siguiendo la plantilla. Columnas requeridas (en orden): Username, Email, Password, Phone.",
    "selectVendorBeforeUpload": "Seleccione un representante antes de cargar datos de clientes.",
    "uploadingParsing": "Cargando y analizando...",
    "pointsLabel": "{count} puntos"
  },
  "vendor": {
    "dashboard": "Panel",
    "clients": "Miembros",
    "analytics": "Analítica",
    "addClient": "Agregar cliente",
    "editClient": "Editar cliente",
    "clientDetails": "Detalles del cliente",
    "totalClients": "Clientes totales",
    "activeClients": "Clientes activos",
    "totalCommission": "Comisión total",
    "clientReferrals": "Referidos de clientes",
    "activeClientsLabel": "Clientes activos",
    "totalProspects": "Prospectos totales",
    "prospectsInPipeline": "En tu pipeline de ventas",
    "percentConverted": "{percent}% convertidos",
    "linkMemberConversions": "Registros por enlace",
    "linkMemberConversionsDesc": "Miembros que se unieron con tu enlace de referido",
    "linkConversionRateLabel": "{percent}% tasa de conversión",
    "assignedClients": "Clientes asignados",
    "totalEarnings": "Ganancias totales",
    "totalReferrals": "Referidos totales",
    "makingReferrals": "Realizando referidos",
    "settings": "Configuración del representante",
    "dashboardTitle": "Panel del representante",
    "clientAnalytics": "Analítica de clientes",
    "analyticsSubtitle": "Supervise el rendimiento de clientes y métricas de referidos",
    "analyticsPeriodHint": "Métricas del periodo seleccionado",
    "clientsSubtitle": "Gestione sus miembros y su actividad de referidos",
    "settingsSubtitle": "Configure su cuenta de representante",
    "notificationsSubtitle": "Actualizaciones importantes y actividad de clientes",
    "promoSubtitle": "Foto, QR por programa, compartir SMS / correo / redes",
    "welcomeOverview": "¡Bienvenido de nuevo, {name}! Aquí tiene un resumen de sus clientes.",
    "vendorPortal": "Portal del representante",
    "vendorPortalDesc": "Gestione sus clientes y el rendimiento de sus referidos.",
    "salesRep": "Representante de ventas",
    "commissionEarned": "Comisión ganada",
    "commissionFromReferrals": "Comisión total por referidos",
    "recentClients": "Clientes recientes",
    "viewAllClients": "Ver todos los clientes",
    "clientOverview": "Resumen de clientes",
    "clientRosterDesc": "Su cartera de clientes y su actividad de referidos",
    "joined": "Registrado",
    "referralsLabel": "referidos",
    "active": "Activo",
    "code": "Código",
    "noClientsYet": "Aún no hay clientes",
    "noClientsYetDesc": "Sus clientes aparecerán aquí cuando se le asignen.",
    "manageClients": "Gestionar clientes",
    "performanceSummary": "Resumen de rendimiento",
    "thisMonth": "Este mes",
    "earned": "ganado",
    "newClientsMonth": "Nuevos clientes (mes)",
    "clientsUnit": "clientes",
    "monthlyReferrals": "Referidos del mes",
    "topClient": "Mejor cliente",
    "completionRate": "Tasa de finalización",
    "failedLoadAnalytics": "No se pudieron cargar los datos de analítica",
    "failedLoadTrends": "No se pudieron cargar las tendencias",
    "errorLoadingClients": "Error al cargar clientes",
    "clientAdvanced": "¡Cliente avanzó al estado {state}!",
    "pointsAwarded": "+{count} puntos otorgados",
    "failedAdvanceState": "No se pudo avanzar el estado del cliente",
    "couldNotLoadReferralTree": "No se pudo cargar el árbol de referidos",
    "managePortfolio": "Gestione y supervise su cartera de miembros",
    "searchClients": "Buscar por nombre, correo o teléfono...",
    "filterByState": "Filtrar por estado",
    "noMatchingMembers": "Ningún miembro coincide con tu búsqueda o filtros.",
    "viewReferralTree": "Ver árbol de referidos",
    "viewReferralTreeFor": "Ver árbol de referidos de {name}",
    "referredBy": "Referido por",
    "rewardPoints": "Puntos de recompensa",
    "referralCode": "Código de referido",
    "advancing": "Avanzando...",
    "advanceTo": "Avanzar a {state}",
    "advanceClientTo": "Avanzar cliente a {state}",
    "confirmAdvanceTitle": "¿Avanzar a {name}?",
    "confirmAdvanceMessage": "¿Mover este cliente a \"{state}\"? Esto actualiza su etapa en el pipeline y puede otorgar puntos.",
    "confirmAdvanceConfirm": "Avanzar etapa",
    "saleCompleted": "¡Venta completada!",
    "saleCompletedFinal": "¡Venta completada — cliente en estado final!",
    "noClientsAssigned": "Sin miembros asignados",
    "noClientsAssignedDesc": "Aún no tiene miembros asignados. Contacte a su administrador para que le asignen miembros.",
    "backToDashboard": "Volver al panel",
    "clientStateDistribution": "Distribución por estado del cliente",
    "prospectStateDistribution": "Distribución por estado del prospecto",
    "monthlyPerformance": "Rendimiento mensual",
    "newClients": "Nuevos clientes",
    "newReferrals": "Nuevos referidos",
    "monthlyCommission": "Comisión mensual",
    "avgPerClient": "Promedio por cliente",
    "topPerformingClients": "Mejores clientes",
    "commission": "Comisión",
    "noActiveClientsYet": "Aún no hay clientes activos",
    "noActiveClientsYetDesc": "Sus clientes aparecerán aquí cuando empiecen a referir.",
    "performanceMetrics": "Métricas de rendimiento",
    "contactRate": "Tasa de contacto",
    "avgReferralsPerClient": "Prom. referidos/cliente",
    "revenuePerClient": "Ingresos por cliente",
    "commissionBreakdown": "Desglose de comisiones",
    "percentOfTotal": "{percent}% del total",
    "commissionRate": "Tasa de comisión",
    "perReferral": "Por referido",
    "allTime": "histórico",
    "percentActive": "{percent}% activos",
    "notAvailable": "N/D",
    "clientSince": "Cliente desde",
    "currentState": "Estado actual",
    "clientJourneyProgress": "Progreso del recorrido del cliente",
    "clientStates": {
      "affiliated": "Afiliado",
      "contacted": "Contactado",
      "visited": "Visitado",
      "completed": "Recompensa entregada"
    },
    "prospects": {
      "title": "Prospectos",
      "subtitle": "Gestione leads en su pipeline de ventas. Importe desde Excel o agregue prospectos uno a uno.",
      "newProspect": "Nuevo prospecto",
      "importExcel": "Importar Excel",
      "downloadTemplate": "Descargar plantilla",
      "failedToDownloadTemplate": "No se pudo descargar la plantilla",
      "excelHint": "Excel: primera fila con encabezados name, opcionales email, phone (EE.UU. (555) 555-0123), address, notes.",
      "loading": "Cargando…",
      "empty": "Aún no hay prospectos. Importe Excel o use Nuevo prospecto para agregar su primer lead.",
      "colProspectionLevel": "Nivel",
      "colName": "Nombre",
      "colType": "Tipo",
      "colAddress": "Dirección",
      "colPhone": "Teléfono",
      "colEmail": "Correo",
      "colStatus": "Estado",
      "colSaleType": "Tipo de venta",
      "colActions": "Acciones",
      "colEnroll": "Enrola",
      "colVendor": "Representante",
      "enroll": "Enrola",
      "typeLabel": "Tipo de prospecto",
      "typeClient": "Cliente",
      "typePartner": "Socio",
      "filterByType": "Filtrar por tipo",
      "enrollPartner": "Enrolar socio",
      "partnerEnrolledSuccess": "¡{name} ya es socio!",
      "confirmEnrollPartnerMessage": "Se creará la cuenta de socio y se le enviará un correo para establecer su contraseña. Saldrá del pipeline de prospectos.",
      "assignLeader": "Asignar líder",
      "noLeader": "Sin líder",
      "enrolledSuccess": "¡{name} ya es cliente!",
      "failedToEnroll": "No se pudo enrolar al prospecto",
      "confirmEnrollTitle": "¿Inscribir a {name} como cliente?",
      "confirmEnrollMessage": "Se moverá a tu lista de clientes y saldrá del pipeline de prospectos. Esta acción no se puede deshacer desde esta pantalla.",
      "adminSubtitle": "Vea todos los prospectos de la empresa y actualice su estado en el pipeline.",
      "adminEmpty": "Aún no hay prospectos en el pipeline.",
      "searchPlaceholder": "Buscar por nombre, correo, teléfono o dirección...",
      "filterByStatus": "Filtrar por estado",
      "filterByVendor": "Filtrar por representante",
      "noMatchingProspects": "Ningún prospecto coincide con tu búsqueda o filtros.",
      "delete": "Eliminar",
      "viewDetails": "Ver detalles",
      "editProspect": "Editar prospecto",
      "editProspectTitle": "Editar prospecto",
      "editModalDesc": "Actualice los datos del prospecto y gestione las notas.",
      "saveChanges": "Guardar cambios",
      "updatedSuccess": "Prospecto actualizado",
      "notesCalendarTitle": "Calendario",
      "notesCalendarSubtitle": "Notas y citas de {name}",
      "notesCalendarPickDay": "Seleccione un día para ver notas o agendar una cita.",
      "calendarAddNoteLabel": "Agregar nota para este día",
      "calendarAddNotePlaceholder": "Escriba una nota para la fecha seleccionada…",
      "notesCalendarNoNotesOnDay": "No hay notas el {date}.",
      "notesCalendarDayTitle": "Actividad del {date}",
      "calendarAppointmentsTitle": "Citas",
      "calendarNoAppointmentsOnDay": "No hay citas este día.",
      "calendarNotesTitle": "Notas",
      "calendarScheduleAppointment": "Agendar cita",
      "calendarStartTime": "Hora de inicio",
      "calendarEndTime": "Hora de fin",
      "calendarInvalidTimeRange": "La hora de fin debe ser posterior a la de inicio.",
      "calendarAppointmentNoteLabel": "Notas de la cita (opcional)",
      "calendarAppointmentNotePlaceholder": "Agregue detalles sobre la visita o reunión…",
      "calendarScheduleAppointmentButton": "Agendar cita",
      "appointmentScheduledSuccess": "Cita agendada",
      "failedToScheduleAppointment": "No se pudo agendar la cita",
      "calendarPrevMonth": "Mes anterior",
      "calendarNextMonth": "Mes siguiente",
      "calendarWeekdays": {
        "sun": "Dom",
        "mon": "Lun",
        "tue": "Mar",
        "wed": "Mié",
        "thu": "Jue",
        "fri": "Vie",
        "sat": "Sáb"
      },
      "addNote": "Agregar nota",
      "addNoteTitle": "Agregar nota",
      "addNoteSubtitle": "Esta nota se guardará con la fecha de hoy ({date}).",
      "addNotePlaceholder": "Escriba una nueva nota para este prospecto…",
      "noteAddedSuccess": "Nota agregada",
      "notesHistory": "Historial de notas",
      "saveNotes": "Guardar notas",
      "notesSaved": "Notas guardadas",
      "detailTitle": "Detalles del prospecto",
      "address": "Dirección",
      "notes": "Notas",
      "noNotes": "Sin notas",
      "createdAt": "Creado",
      "updatedAt": "Última actualización",
      "close": "Cerrar",
      "confirmDelete": "¿Eliminar prospecto \"{name}\"?",
      "createdSuccess": "Prospecto creado",
      "deletedSuccess": "Prospecto eliminado",
      "importSuccess": "Se importaron {count} fila(s)",
      "failedToLoad": "No se pudieron cargar los prospectos",
      "failedToCreate": "No se pudo crear el prospecto",
      "failedToUpdate": "No se pudo actualizar el prospecto",
      "failedToDelete": "No se pudo eliminar el prospecto",
      "failedToImport": "No se pudo importar la hoja de cálculo",
      "createModalDesc": "Guarde el prospecto en su pipeline. Los datos de contacto son opcionales y puede editarlos después.",
      "nameRequired": "El nombre es obligatorio",
      "emailInvalid": "Ingrese un correo electrónico válido",
      "phoneInvalid": "Ingrese un número de teléfono válido de 10 dígitos (EE.UU.)",
      "nameLabel": "Nombre completo o negocio *",
      "namePlaceholder": "ej. Jane Smith o Acme Water Co.",
      "emailLabel": "Correo",
      "emailPlaceholder": "nombre@empresa.com",
      "phoneLabel": "Teléfono",
      "addressLabel": "Dirección",
      "addressPlaceholder": "123 Main St, Ciudad, ST 12345 (opcional)",
      "apartmentLabel": "Apartamento",
      "apartmentPlaceholder": "Apto, suite, unidad… (opcional)",
      "creationProfileTitle": "Creación de Prospecto",
      "creationProfileOptional": "Opcional — puede dejarlas sin responder si no lo sabe.",
      "worksLabel": "¿Trabaja?",
      "marriedLabel": "¿Casado?",
      "housingLabel": "¿Casa o alquiler?",
      "ownsHomeLabel": "Casa",
      "rentsHomeLabel": "Alquiler",
      "prospectionLevelLabel": "Nivel de prospección",
      "prospectionLevelHint": "Opcional — califique la calidad de este prospecto de 1 a 5 estrellas.",
      "addressSearching": "Buscando direcciones…",
      "notesLabel": "Notas",
      "notesPlaceholder": "Contexto para su equipo — siguiente paso, origen, etc.",
      "statusLabel": "Estado del prospecto",
      "saleType": "Tipo de venta",
      "saleTypeUnset": "Aún no definido",
      "back": "Atrás",
      "next": "Siguiente",
      "saving": "Guardando…",
      "create": "Crear prospecto",
      "statuses": {
        "NEW": "Nuevo",
        "CALL": "Llamada",
        "VISIT": "Visita",
        "DEMO": "Demo",
        "SALE": "Venta",
        "INTERVIEW": "Entrevistado",
        "NOT_INTERESTED": "No interesado"
      },
      "saleTypes": {
        "CASH": "Contado",
        "CREDIT": "Crédito"
      }
    }
  },
  "rewards": {
    "title": "Configuración de recompensas",
    "pointConfigs": "Configuración de puntos",
    "rewards": "Recompensas",
    "addReward": "Agregar recompensa",
    "editReward": "Editar recompensa",
    "deleteReward": "Eliminar recompensa",
    "name": "Nombre",
    "description": "Descripción",
    "pointsRequired": "Puntos requeridos",
    "save": "Guardar",
    "cancel": "Cancelar",
    "edit": "Editar",
    "delete": "Eliminar",
    "create": "Crear",
    "update": "Actualizar",
    "savedSuccessfully": "¡Configuración de puntos guardada correctamente!",
    "failedToSave": "No se pudieron guardar las configuraciones",
    "createdSuccessfully": "¡Recompensa creada correctamente!",
    "failedToCreate": "No se pudo crear la recompensa",
    "updatedSuccessfully": "¡Recompensa actualizada correctamente!",
    "failedToUpdate": "No se pudo actualizar la recompensa",
    "deletedSuccessfully": "¡Recompensa eliminada correctamente!",
    "failedToDelete": "No se pudo eliminar la recompensa",
    "fillRequiredFields": "Complete todos los campos obligatorios",
    "loading": "Cargando configuración de recompensas...",
    "failedToLoad": "No se pudo cargar la configuración de recompensas",
    "rewardsConfiguration": "Configuración de recompensas",
    "configureRewardPoints": "Configure puntos de recompensa por estado del cliente y gestione las recompensas disponibles",
    "stateRewardPoints": "Puntos por estado",
    "configurePointsAwarded": "Configure los puntos otorgados a los referidores cuando sus clientes referidos avanzan por los estados",
    "editPoints": "Editar puntos",
    "rewardPoints": "Puntos de recompensa",
    "whenClientRefers": "Cuando un cliente refiere a otra persona",
    "whenSellerContacts": "Cuando el representante contacta al afiliado por teléfono",
    "whenSellerVisits": "Cuando el representante visita al afiliado en persona",
    "whenSaleCompleted": "Cuando se completa la venta",
    "rewardsCatalog": "Catálogo de recompensas",
    "manageRewardsRedeem": "Gestione recompensas que los clientes pueden canjear con sus puntos",
    "noRewardsYet": "Aún no hay recompensas",
    "createFirstReward": "Cree su primera recompensa para que los clientes canjeen",
    "points": "puntos",
    "inactive": "Inactivo",
    "createReward": "Crear recompensa",
    "createNewReward": "Crear nueva recompensa",
    "rewardName": "Nombre de la recompensa",
    "active": "Activo",
    "confirmDeleteReward": "¿Está seguro de que desea eliminar esta recompensa?",
    "describeReward": "Describa la recompensa...",
    "rewardNamePlaceholder": "p. ej., tarjeta regalo de $50",
    "welcomeBonusSection": "Bono de bienvenida",
    "welcomeBonusSectionDesc": "Puntos regalados automaticamente a cada cliente nuevo al unirse a la plataforma",
    "welcomeBonus": "Bono de bienvenida para nuevos miembros",
    "welcomeBonusDesc": "Se otorga una sola vez cuando el cliente crea su cuenta",
    "imageUrl": "URL de imagen del producto",
    "imageUrlPlaceholder": "/api/rewards/images/foto-producto.jpg",
    "imageSection": "Imagen del producto",
    "imageUpload": "Subir desde dispositivo",
    "imageUploading": "Subiendo...",
    "imageUploaded": "Imagen subida correctamente.",
    "imageUploadFailed": "No se pudo subir la imagen.",
    "imageUploadHint": "Sube un archivo o pega una URL. PNG, JPG, WEBP o GIF, máximo 5 MB.",
    "imageInvalidType": "Seleccione una imagen válida (PNG, JPG, WEBP o GIF).",
    "imageTooLarge": "La imagen es demasiado grande. Tamaño máximo: 5 MB.",
    "formPreview": "Vista previa de la tarjeta",
    "formPreviewHint": "Actualiza la URL para cambiar cómo se muestra esta recompensa en el catálogo.",
    "formPreviewExpand": "Ver imagen completa",
    "formPreviewExpandHint": "Haz clic en la vista previa para ver la imagen completa.",
    "formImageViewTitle": "Imagen de la recompensa",
    "formDetails": "Detalles de la recompensa",
    "welcomeChoiceLabel": "Mostrar como opción de regalo de bienvenida",
    "welcomeChoiceBadge": "Regalo de bienvenida",
    "deliverySettingsTitle": "Plazos de entrega de regalos",
    "deliverySettingsDesc": "Defina cuántos días tiene el representante para entregar, en qué día aparece el aviso de retraso y qué plazo se le comunica al cliente.",
    "editDeliverySettings": "Editar plazos",
    "deliverySettingsSaved": "Plazos de entrega guardados correctamente",
    "deliverySettingsFailed": "No se pudieron guardar los plazos de entrega",
    "deliveryOverdueDayInvalid": "El día de aviso de retraso no puede ser mayor al plazo de entrega del representante",
    "vendorDeliveryDaysLabel": "Plazo de entrega del representante",
    "vendorDeliveryDaysDesc": "Días que tiene el representante para entregar el regalo después de recibirlo del administrador",
    "vendorOverdueDayLabel": "Día de aviso de retraso",
    "vendorOverdueDayDesc": "En este día del plazo de entrega se muestra una alerta roja de retraso al representante",
    "clientDeliveryDaysLabel": "Plazo prometido al cliente",
    "clientDeliveryDaysDesc": "Indique al cliente que recibirá su regalo en menos de esta cantidad de días",
    "shortActionsSection": "Puntos de acciones rápidas",
    "shortActionsSectionDesc": "Active o desactive cada acción rápida y configure los puntos extra al completarla",
    "shortActionsVendorNote": "Las acciones de vendedores también pueden otorgar puntos extra",
    "clientShortActionsLabel": "Acciones de clientes",
    "vendorShortActionsLabel": "Acciones de vendedores",
    "daysUnit": "días",
    "dayNumber": "Día {day}"
  },
  "welcomeOnboarding": {
    "eyebrow": "Bienvenida",
    "title": "Hola, {name}",
    "subtitle": "Tu cuenta ya está activa. Te hemos acreditado un bono de bienvenida para que empieces con ventaja.",
    "subtitleElevate": "Tu cuenta ya está activa. Te hemos acreditado {points} puntos — equivalentes al 10% de descuento en tu boleto del evento Elevate Hispano.",
    "bonusLabel": "Bono acreditado",
    "pointsGifted": "puntos añadidos a tu saldo",
    "acceptBonus": "Continuar",
    "readyEyebrow": "Regalo de bienvenida",
    "rewardReadyTitle": "Elige tu regalo",
    "rewardReadySubtitle": "Tienes {points} puntos disponibles. Selecciona el beneficio que deseas canjear ahora.",
    "chooseRewardHint": "Todas las opciones requieren la misma cantidad de puntos.",
    "chooseRewardHintElevate": "Canjea tus {points} puntos por el 10% de descuento en tu boleto del evento.",
    "selectedRewardLabel": "Seleccionado: {reward}",
    "selectReward": "Selecciona un regalo de bienvenida para continuar.",
    "claimingReward": "Procesando canje...",
    "claimFailed": "No se pudo canjear el regalo seleccionado. Inténtalo de nuevo.",
    "defaultRewardName": "Royal Prestige® Santoku Knife 5\"",
    "defaultRewardDescription": "Cuchillo Santoku de 5\" con acero inoxidable aleman — ideal para rebanar, picar y preparar ingredientes.",
    "pointsBadge": "{count} pts",
    "redeemNow": "Canjear regalo",
    "backToBonus": "Volver",
    "friendFallback": "amigo"
  },
  "enrola": {
    "giftsHome": "Inicio",
    "motivationalBanner": {
      "greeting": "Hola, {name}"
    },
    "clientHome": {
      "homeSubtitle": "Explore recompensas, consulte sus puntos e invite amigos en un solo lugar.",
      "welcomeEyebrow": "Su tienda de recompensas",
      "welcomeTitle": "Hola, {name}",
      "welcomeSubtitle": "Canjee puntos por regalos y haga crecer su red con un escaneo rápido.",
      "pointsBalance": "Saldo de puntos",
      "viewAllRewards": "Ver todas las recompensas",
      "nextGift": "Próximo regalo",
      "shopEyebrow": "Canjear",
      "shopTitle": "Recompensas populares",
      "shopSubtitle": "Reclame regalos con sus puntos — la entrega se sigue en su cuenta.",
      "viewCatalog": "Ver catálogo completo",
      "inviteEyebrow": "Invitación rápida",
      "inviteTitle": "Referir a un amigo",
      "inviteSubtitle": "Comparta su enlace o deje que escaneen su código QR.",
      "scanToJoin": "Escanee para unirse al programa",
      "openReferrals": "Todos los programas de referidos",
      "noInviteLink": "Su enlace de invitación se está preparando.",
      "referralsEyebrow": "Su red",
      "referralsTitle": "Personas que ha referido",
      "viewAllReferrals": "Ver todos",
      "noReferralsYet": "Aún no tiene referidos — comparta su código QR para comenzar.",
      "inviteFirstReferral": "Invitar a alguien"
    },
    "partnerHome": {
      "inviteEyebrow": "Programa de socios",
      "inviteTitle": "Invitar a un socio",
      "inviteSubtitle": "Comparta su enlace o deje que escaneen el código QR para unirse como vendedores.",
      "scanToJoin": "Escanee para unirse como socio",
      "openReferrals": "Programa de socios",
      "noInviteLink": "Su enlace de socios se está preparando."
    },
    "inviteSwitchClients": "Clientes",
    "inviteSwitchPartners": "Socios",
    "shortActions": {
      "eyebrow": "Crece hoy",
      "title": "Acciones rápidas",
      "motivationClient": "Completa estos atajos para hacer crecer tu red y ganar puntos extra.",
      "motivationVendor": "Completa estos atajos para hacer crecer tu negocio y ganar puntos extra.",
      "shareLinkToday": "Comparte tu enlace de invitación hoy",
      "shareLinkTodayDesc": "Copia o comparte tu enlace una vez hoy",
      "invite1Today": "Invita a 1 persona nueva hoy",
      "invite1TodayDesc": "Comparte tu enlace — {current}/{target} registrados hoy",
      "invite3Today": "Invita a 3 personas nuevas hoy",
      "invite3TodayDesc": "Comparte tu enlace — {current}/{target} registrados hoy",
      "invite5Today": "Invita a 5 personas nuevas hoy",
      "invite5TodayDesc": "Comparte tu enlace — {current}/{target} registrados hoy",
      "browseRewardsToday": "Visita la tienda de recompensas",
      "browseRewardsTodayDesc": "Revisa las recompensas disponibles",
      "welcomeAffiliated": "Da la bienvenida a {name}",
      "welcomeAffiliatedDesc": "Envía un correo de bienvenida a tu referido afiliado",
      "remindContacted": "Recuerda a {name} sobre su visita",
      "remindContactedDesc": "{vendorName} se pondrá en contacto pronto",
      "remindVisited": "Anima a {name} después de su visita",
      "remindVisitedDesc": "Envía un correo motivacional para terminar fuerte",
      "congratulateCompleted": "Felicitaciones a {name}",
      "congratulateCompletedDesc": "Celebra a un referido que completó su proceso",
      "callAffiliated": "Llama al miembro afiliado {name}",
      "callAffiliatedDesc": "Toca para copiar su número telefónico",
      "callContacted": "Llama al miembro contactado {name}",
      "callContactedDesc": "Haz seguimiento mientras está en etapa contactado",
      "followUpVisited": "Haz seguimiento a {name}",
      "followUpVisitedDesc": "Toca para copiar su número telefónico",
      "followUpCompleted": "Haz seguimiento a {name}",
      "followUpCompletedDesc": "Toca para copiar su número telefónico",
      "create1Prospect": "Genera 1 prospecto nuevo hoy",
      "create1ProspectDesc": "Progreso: {current}/{target} creados hoy",
      "create3Prospects": "Genera 3 prospectos nuevos hoy",
      "create3ProspectsDesc": "Progreso: {current}/{target} creados hoy",
      "create5Prospects": "Genera 5 prospectos nuevos hoy",
      "create5ProspectsDesc": "Progreso: {current}/{target} creados hoy",
      "enrollProspectToday": "Enrola 1 prospecto como miembro hoy",
      "enrollProspectTodayDesc": "Progreso: {current}/{target} enrolados como miembros hoy",
      "enroll2ProspectsToday": "Enrola 2 prospectos como clientes hoy",
      "enroll2ProspectsTodayDesc": "Progreso: {current}/{target} enrolados hoy",
      "advanceMemberToday": "Avanza 1 cliente de etapa hoy",
      "advanceMemberTodayDesc": "Progreso: {current}/{target} avanzados hoy",
      "advance3MembersToday": "Avanza 3 clientes de etapa hoy",
      "advance3MembersTodayDesc": "Progreso: {current}/{target} avanzados hoy",
      "deliverGiftToday": "Entrega 1 regalo pendiente hoy",
      "deliverGiftTodayDesc": "Progreso: {current}/{target} entregados hoy",
      "reviewPendingGifts": "Revisa regalos pendientes",
      "reviewPendingGiftsDesc": "{count} regalo(s) esperando entrega",
      "highReward": "Alta recompensa",
      "completed": "Listo",
      "completedToday": "Completadas hoy",
      "pointsBadge": "+{count} pts",
      "pointsEarned": "¡Ganaste {count} puntos extra!",
      "linkCopied": "¡Enlace de invitación copiado!",
      "phoneCopied": "¡Número telefónico copiado!",
      "noPhone": "Este miembro no tiene teléfono registrado",
      "shareTitle": "Comparte tu enlace de invitación",
      "shareSubtitle": "Copia tu enlace o compártelo directamente en redes sociales.",
      "pendingCount": "{count} acción(es) te esperan",
      "vendorFallback": "su representante",
      "progressLabel": "Progreso",
      "ctaShare": "Comparte tu enlace",
      "ctaRemind": "Enviar correo de recordatorio",
      "ctaCall": "Copiar número telefónico",
      "ctaProspects": "Ir a prospectos",
      "ctaClients": "Ir a clientes",
      "ctaMembers": "Ir a miembros",
      "ctaRewards": "Ir a recompensas",
      "ctaPendingGifts": "Ir a regalos pendientes",
      "allDone": "¡Todo al día por hoy — excelente trabajo!",
      "slideNext": "Desliza la esquina para ver la siguiente",
      "scrollPrev": "Acciones anteriores",
      "scrollNext": "Siguientes acciones",
      "yourLink": "Tu enlace de invitación",
      "emailTemplates": {
        "welcomeAffiliated": {
          "subject": "¡Bienvenido/a, {name}!",
          "body": "Hola {name},\n\n¡Nos alegra tenerte en nuestra comunidad! Tu proceso está por comenzar y {vendorName} estará contigo en cada paso.\n\n¡Bienvenido/a!"
        },
        "remindVisited": {
          "subject": "¡Ya casi terminas, {name}!",
          "body": "Hola {name},\n\n¡Felicitaciones por tu progreso! Ya completaste tu visita y estás muy cerca de finalizar tu proceso. Si tienes alguna pregunta, no dudes en contactarnos.\n\n¡Sigue así!"
        },
        "congratulateCompleted": {
          "subject": "¡Felicitaciones, {name}!",
          "body": "Hola {name},\n\n¡Enhorabuena por completar todo tu proceso! Gracias por confiar en nosotros. Esperamos seguir creciendo juntos.\n\n¡Un abrazo!"
        },
        "remindContacted": {
          "subject": "Recordatorio: visita de {vendorName}",
          "body": "Hola {name},\n\n¡Esperamos que estés muy bien! Te escribimos para recordarte que {vendorName} estará visitándote o contactándote muy pronto. Estate atento a su llamada o visita.\n\n¡Saludos!"
        }
      },
      "actionLabels": {
        "share_link_today": "Compartir enlace hoy",
        "invite_3_today": "Invitar 3 personas hoy",
        "browse_rewards_today": "Visitar tienda de recompensas",
        "welcome_affiliated": "Bienvenida a referido afiliado",
        "remind_contacted": "Recordar referido contactado",
        "remind_visited": "Animar referido visitado",
        "congratulate_completed": "Felicitaciones a referido completado",
        "call_affiliated": "Llamar miembro afiliado",
        "call_contacted": "Llamar miembro contactado",
        "follow_up_visited": "Seguimiento a miembro visitado",
        "follow_up_completed": "Seguimiento a miembro completado",
        "create_3_prospects_today": "Crear 3 prospectos hoy",
        "enroll_prospect_today": "Enrolar 1 prospecto como miembro hoy",
        "advance_member_today": "Avanzar 1 cliente hoy",
        "deliver_gift_today": "Entregar 1 regalo hoy",
        "review_pending_gifts": "Revisar regalos pendientes"
      },
      "actionDescriptions": {
        "share_link_today": "Compartir enlace de referido una vez al día",
        "invite_3_today": "Bono cuando 3 personas se registran con tu enlace en un día",
        "browse_rewards_today": "Visitar la tienda de recompensas una vez al día",
        "welcome_affiliated": "Enviar correo de bienvenida a referido afiliado",
        "remind_contacted": "Enviar recordatorio amigable a referido en estado contactado",
        "remind_visited": "Enviar ánimo a referido en estado visitado",
        "congratulate_completed": "Felicitaciones a referido que completó su proceso",
        "call_affiliated": "Copiar teléfono y llamar miembro afiliado",
        "call_contacted": "Copiar teléfono y llamar miembro contactado",
        "follow_up_visited": "Copiar teléfono y hacer seguimiento a miembro visitado",
        "follow_up_completed": "Copiar teléfono y hacer seguimiento a miembro completado",
        "create_3_prospects_today": "Crear 3 prospectos nuevos en un día",
        "enroll_prospect_today": "Enrolar al menos 1 prospecto como miembro hoy",
        "advance_member_today": "Avanzar al menos 1 cliente a la siguiente etapa hoy",
        "deliver_gift_today": "Marcar al menos 1 regalo pendiente como entregado hoy",
        "review_pending_gifts": "Revisar regalos que esperan entrega"
      }
    },
    "vendorHome": {
      "homeSubtitle": "Cree prospectos, entregue regalos y haga crecer su pipeline de ventas.",
      "welcomeEyebrow": "Centro de ventas",
      "welcomeTitle": "¿Listo para vender, {name}?",
      "welcomeSubtitle": "Cada prospecto y cliente satisfecho lo acerca a sus metas. Empiece con una acción rápida abajo.",
      "statClients": "Clientes",
      "statReferrals": "Referidos",
      "statCommission": "Comisión",
      "quickActionsEyebrow": "Acción rápida",
      "quickActionsTitle": "Acciones rápidas",
      "shortcutsEyebrow": "Acceso directo",
      "shortcutsTitle": "Accesos directos",
      "shortcutsSubtitle": "Ve directo a las herramientas que más usas cada día.",
      "createProspectEyebrow": "Nuevo lead",
      "createProspectTitle": "Crear prospecto",
      "createProspectSubtitle": "Agregue un lead en segundos y sígalo hasta la inscripción.",
      "createProspectCta": "Nuevo prospecto",
      "pendingGiftsEyebrow": "Entregas",
      "pendingGiftsTitle": "Regalos pendientes",
      "pendingGiftsNone": "Sin regalos pendientes — sus clientes están al día.",
      "pendingGiftsCount": "{count} por entregar · {awaiting} esperando admin",
      "pendingGiftsCta": "Gestionar regalos",
      "clientsEyebrow": "Clientes",
      "clientsTitle": "Ver clientes",
      "clientsSubtitle": "Revise su cartera de clientes y su estado actual.",
      "clientsCta": "Ver clientes",
      "performanceEyebrow": "Este mes",
      "performanceTitle": "Su rendimiento",
      "viewAnalytics": "Analíticas completas",
      "newClientsEyebrow": "Pipeline",
      "newClientsTitle": "Clientes recientes",
      "viewAllClients": "Todos los clientes",
      "noClientsYet": "Aún no tiene clientes — cree un prospecto o comparta su QR para empezar.",
      "inviteEyebrow": "Crece más rápido",
      "inviteTitle": "Su QR de referidos",
      "inviteSubtitle": "Deje que los prospectos escaneen y se unan a su programa al instante.",
      "scanToJoin": "Escanee para unirse como su cliente",
      "openReferrals": "Promo y programas de referidos",
      "noInviteLink": "Su enlace de referidos se está preparando."
    },
    "adminHome": {
      "homeSubtitle": "Su equipo, pipeline y acciones pendientes en un solo lugar.",
      "welcomeEyebrow": "Centro admin",
      "welcomeTitle": "Hola, {name}",
      "welcomeSubtitle": "Vea cómo va su programa y qué necesita su atención hoy.",
      "statUsers": "Usuarios",
      "statUsersSub": "{admins} administradores",
      "statVendors": "Representantes",
      "statVendorsSub": "Prom. {avg} clientes / representante",
      "statClients": "Clientes",
      "statClientsSub": "{rate}% conversión de enlaces",
      "statReferrals": "Referidos",
      "statReferralsSub": "{active} referidores activos",
      "pipelineEyebrow": "Pipeline",
      "pipelineTitle": "Clientes por etapa",
      "vendorsEyebrow": "Equipo",
      "vendorsTitle": "Top Representantes",
      "vendorsEmpty": "Sin datos de representantes aún",
      "viewUsers": "Gestionar usuarios",
      "viewAnalytics": "Analíticas",
      "pendingGiftsEyebrow": "Requiere acción",
      "pendingGiftsTitle": "Entregas de regalos pendientes",
      "pendingGiftsNone": "No hay regalos esperando entrega del admin.",
      "pendingGiftsCount": "{count} reclamo(s) requieren su revisión",
      "pendingGiftsCta": "Revisar regalos pendientes",
      "systemConfigTitle": "Configuración del sistema",
      "systemConfigSubtitle": "Estados del pipeline de prospectos",
      "statusCount": "{active} activos de {total} estados configurados",
      "noStatuses": "Aún no hay estados configurados",
      "configureSystem": "Abrir configuración del sistema",
      "inviteEyebrow": "Invitar clientes",
      "inviteTitle": "Su QR de invitación",
      "inviteSubtitle": "Comparta el enlace o deje que escaneen el código para unirse como clientes.",
      "scanToJoin": "Escanee para unirse a su empresa",
      "openReferrals": "Programas y enlaces Enrola",
      "noInviteLink": "Su enlace de invitación se está preparando.",
      "linksTitle": "Enlaces de referidos",
      "activeLinksLabel": "Enlaces activos",
      "clicksLabel": "Clics totales",
      "conversionsLabel": "Conversiones",
      "conversionRateLabel": "Tasa de conversión",
      "notificationsTitle": "Notificaciones",
      "unreadCount": "{count} alerta(s) sin leer",
      "noUnreadNotifications": "Sin notificaciones sin leer",
      "viewNotifications": "Ver notificaciones"
    },
    "programs": "Programas de referidos",
    "wallet": "Billetera",
    "club": "Club de compras",
    "promoCard": "Promoción y tarjeta virtual",
    "enrolaHub": "Centro Enrola",
    "adminHubSubtitle": "Enlaces, soporte, mercado, billetera y campañas",
    "corporate": "Corporativo",
    "giftsTitle": "Regalos disponibles",
    "giftsSubtitle": "Canjee sus puntos por recompensas (tasa base: $1 = 100 pts). Active incentivo en dinero para programas de socios cuando aplique.",
    "pointsHistory": "Ver historial de puntos",
    "programCountdownTitle": "Programa {current}/{total}",
    "programLastDay": "Último día: cierre sus referidos hoy",
    "programDaysLeft": "{count} día(s) restante(s) para completar el programa",
    "programTip": "Consejo 4/14: cada referido válido le acerca al siguiente regalo. Comparta hoy.",
    "shareQuick": "Compartir rápido",
    "shareSuggested": "Mensajes sugeridos",
    "sharePreview": "Vista previa",
    "copyMessage": "Copiar mensaje",
    "messageCopied": "Mensaje copiado",
    "copyFailed": "No se pudo copiar",
    "redeemAvailable": "Canjear (vista)",
    "pointsNeeded": "Faltan {count} pts",
    "cashIncentiveLabel": "Incentivo en dinero (reclutamiento de socios)",
    "cashIncentiveHint": "Solo visual: la empresa define las reglas; aquí indica preferencia para campañas de socios.",
    "conversionRate": "Tasa de conversión: $1 = 100 puntos. Refiera más para desbloquear regalos exclusivos.",
    "nextRewardLevel": "Siguiente nivel de recompensa",
    "gamificationDesc": "Mensajes persuasivos y gamificación: avance para desbloquear más beneficios. En producción: notificaciones en app, SMS y correo.",
    "pointsLabel": "puntos",
    "goalLabel": "Meta {count} pts",
    "referMore": "Refiera más para subir de nivel y acceder a regalos exclusivos.",
    "programsSubtitle": "Gane confianza con un flujo claro: su nivel, sus números y dos enlaces (clientes y socios) con QR y kit para compartir.",
    "clicks": "Clics",
    "clicksAllLinks": "En todos sus enlaces",
    "conversionsLabel": "Conversiones",
    "conversionsViaLink": "Registros vía su enlace",
    "activePrograms": "Enlaces activos",
    "programsAvailable": "Programas disponibles",
    "referralProgramsBtn": "Programas de referidos",
    "walletBtn": "Billetera",
    "shoppingClubBtn": "Club de compras",
    "viewAnalytics": "Ver analíticas",
    "viewNetwork": "Ver red",
    "quickActions": "Acciones rápidas",
    "programClientsLabel": "Programa clientes",
    "programPartnersLabel": "Programa socios",
    "newClientsSubtitle": "Nuevos clientes",
    "partnerRecruitmentSubtitle": "Reclutamiento de socios",
    "linkCopied": "Enlace copiado",
    "qrDownloaded": "QR descargado",
    "copyLink": "Copiar enlace",
    "share": "Compartir",
    "showQR": "Ver QR",
    "hideQR": "Ocultar QR",
    "downloadQR": "Descargar QR",
    "defaultShareClients": "Únete con mi programa de clientes Enrola y obtén beneficios exclusivos: {url}",
    "defaultSharePartners": "Gana con el programa de socios Enrola. Primeros 3 negocios: $250. Invitación: {url}",
    "defaultShareFallback": "Únete con mi enlace Enrola: {url}",
    "suggestedMessage": "Mensaje sugerido",
    "copyMessageTitle": "Copiar mensaje",
    "referralsCount": "{count} referidos",
    "totalReferralsLabel": "Total referidos",
    "yourReferrals": "Tus referidos",
    "customLinkLabel": "Enlace personalizado",
    "copiedShort": "Copiado",
    "copyShort": "Copiar",
    "shareOn": "Compartir en:",
    "shareKitLabel": "Kit de compartir",
    "invitationTitle": "Invitación — {label}",
    "shareModalHint": "Copia el enlace o comparte en un toque.",
    "yourLink": "Tu enlace",
    "scanToOpen": "Escanea para abrir tu invitación",
    "programsPreviewTitle": "Tus programas (vista previa)",
    "programsPreviewSubtitle": "Dos enlaces fijos: clientes y socios. Abre la sección completa desde el menú.",
    "network": {
      "eyebrow": "Red",
      "title": "Tu red",
      "subtitle": "Personas que invitaste a la plataforma",
      "subtitleTimeline": "Cada invitado muestra su recorrido: registrado → verificado → recompensa entregada.",
      "summary": "Resumen",
      "active": "Activos",
      "referralsGenerated": "Referidos generados",
      "members": "Miembros",
      "timelineHint": "Estado del pipeline por invitado",
      "total": "Total",
      "completed": "Completados",
      "noInviteesTitle": "Aún no hay invitados",
      "noInviteesDesc": "Cuando alguien use tu enlace y se registre, aparecerá aquí con su estado paso a paso.",
      "shareMyLink": "Compartir mi enlace",
      "pipeline": {
        "registered": "Registrado",
        "verified": "Verificado",
        "rewardPaid": "Recompensa entregada"
      }
    },
    "shareKit": {
      "defaultMessage": "Únete con mi enlace Enrola: {url}",
      "whatsapp": "WhatsApp",
      "telegram": "Telegram",
      "email": "Correo",
      "emailSubject": "Únete conmigo en Enrola"
    },
    "inviteContacts": {
      "label": "Invitar mis contactos",
      "subtitle": "Elige contactos en tu teléfono y envíales un SMS con tu enlace de referido.",
      "loading": "Abriendo contactos…",
      "openingSms": "Abriendo Mensajes con {count} contacto(s)",
      "openingMessages": "Abriendo Mensajes — agrega tus contactos y envía",
      "desktopCopied": "Mensaje copiado — ábrelo en tu teléfono para enviarlo por SMS",
      "failed": "No se pudieron abrir tus contactos. Intenta de nuevo desde tu teléfono.",
      "miniCard": {
        "eyebrow": "Desde tu teléfono",
        "title": "Tus contactos están a un toque",
        "body": "Elige amigos y familiares de tu lista — la invitación sale por SMS en segundos.",
        "contactsHint": "Todos en tu agenda",
        "footerHint": "Tú eliges quién recibe el mensaje",
        "messageLanguage": "Idioma del mensaje"
      }
    },
    "referralTree": {
      "dialogLabel": "Referidos directos de {name}",
      "title": "Referidos directos",
      "directCount": "· {count} referido(s) directo(s)",
      "close": "Cerrar árbol de referidos",
      "emptyTitle": "Aún no hay referidos directos",
      "emptyDesc": "Solo aparecerán aquí las personas que se registraron directamente a través de este cliente.",
      "sectionLabel": "Referidos directos"
    },
    "walletView": {
      "subtitle": "Puntos y dinero: recompensas habilitadas y saldo listo para retirar (vista previa).",
      "points": "Puntos",
      "pointsAccumulated": "Acumulados en campañas",
      "readyToCollect": "Listo para cobrar",
      "withdrawRequestHint": "Solicita retiro cuando esté habilitado",
      "moneyEnabled": "Dinero habilitado",
      "moneyRules": "Disponible según reglas de la empresa",
      "readyToWithdraw": "Listo para retirar",
      "withdrawHint": "Vista previa — flujo de retiro en producción",
      "recentMovements": "Movimientos recientes"
    },
    "clubView": {
      "subtitle": "E-commerce de productos y servicios con tu billetera (vista previa).",
      "product": "Producto",
      "service": "Servicio",
      "buyWithWallet": "Compra con puntos o dinero",
      "elevateSubtitle": "Compra tu entrada al evento Elevate Hispanos y únete a Evolución 90 desde el club de compras.",
      "elevateEyebrow": "Evento",
      "elevateTitle": "Elevate Hispanos",
      "elevateEventLine": "Las Vegas · 14 de noviembre, 2026",
      "elevateDescription": "Compra ahora tu entrada de preventa y asegura tu lugar.",
      "elevateBuyCta": "Comprar entrada",
      "welcomeDiscountBadge": "{percent}% OFF regalo de bienvenida",
      "welcomeDiscountDescription": "Tu regalo de bienvenida está activo: {percent}% de descuento en la entrada de este evento.",
      "welcomeDiscountBuyCta": "Comprar con {percent}% off",
      "welcomeDiscountNextStep": "Abre el Club de compras y usa tu 10% en la entrada de Elevate Hispanos.",
      "evolucion90Eyebrow": "EVOLUCIÓN 90™ · Semana 02",
      "evolucion90Brand": "Elantar Academy",
      "evolucion90OverlayTitle": "EVOLUCIÓN 90™",
      "evolucion90WeekLabel": "Semana 02",
      "evolucion90Title": "De Productor a Líder",
      "evolucion90EventLine": "Jueves 27 de agosto, 2026 · 5:00–6:30 PM (PT)",
      "evolucion90Description": "Da el salto de productor a líder. Encuentro en vivo por Zoom con Freddy Reynoso.",
      "evolucion90Cta": "Asistir a Evolucion 90"
    },
    "corporateView": {
      "subtitle": "Firma electrónica, posventa e integración ELANTAR One (vista previa — habilitar por contrato).",
      "esignTitle": "Firma electrónica",
      "esignDesc": "Firma documentos digitalmente desde el portal.",
      "afterSalesTitle": "Posventa",
      "services": "Servicios",
      "maintenance": "Mantenimiento",
      "warranties": "Garantías",
      "elantarOneTitle": "ELANTAR One",
      "elantarOneDesc": "Hub corporativo unificado (vista previa).",
      "esignExtendedDesc": "Precalificación de ventas, contratos y garantías.",
      "openPendingDocs": "Abrir documentos pendientes",
      "newRequest": "Nueva solicitud",
      "elantarOneExtendedDesc": "Reclutamiento crea usuario automático; programa clientes crea prospecto (corporativo).",
      "syncInDevelopment": "Sincronización en desarrollo"
    },
    "promoView": {
      "eyebrow": "Representante",
      "subtitle": "Sube tu foto, genera tu tarjeta de promotor y comparte enlaces y QR por programa.",
      "profilePhoto": "Foto de perfil",
      "uploadPhoto": "Subir foto",
      "localDemoHint": "Imagen demo local — en producción se usa la foto de tu cuenta.",
      "promoter": "Promotor",
      "vendorFallback": "Representante",
      "defaultShareMessage": "Soy promotor Enrola — programa clientes: {url}",
      "settingsPhotoHint": "Actualice su foto de perfil en Configuración → Perfil."
    },
    "partnerNetworkView": {
      "eyebrow": "Enrola",
      "title": "Red de socios",
      "subtitle": "Socios que has reclutado y prospectos de socio pendientes de enrolar.",
      "newPartner": "Nuevo socio",
      "partnersCount": "Socios reclutados",
      "pendingCount": "Prospectos pendientes",
      "pendingTitle": "Prospectos de socio pendientes",
      "pendingSubtitle": "Registros del programa de socios que esperan ser enrolados.",
      "noPending": "No hay prospectos de socio pendientes",
      "noPendingDesc": "Los nuevos registros de socios aparecerán aquí.",
      "manage": "Gestionar",
      "partnersTitle": "Mis socios",
      "partnersSubtitle": "Socios que reclutaste directamente.",
      "noPartners": "Aún no tienes socios",
      "noPartnersDesc": "Comparte tu enlace de socios para empezar a construir tu red.",
      "partnerBadge": "Socio",
      "failedToLoad": "No se pudo cargar tu red de socios"
    },
    "tiers": {
      "bronze": "Bronce",
      "silver": "Plata",
      "gold": "Oro",
      "gamification": "Gamificación",
      "levelUpTitle": "Refiere para subir de nivel",
      "progressSummary": "{count} referido(s) · Meta Oro: {goal}",
      "referralsShort": "{count} ref.",
      "nextBenefit": "Próximo beneficio",
      "referralsToUnlock": "Faltan {count} referido(s) para desbloquear",
      "bronzeBonus": "+50 pts en primer alta válida",
      "silverBonus": "+100 pts bonus en Plata",
      "goldBonus": "Regalos exclusivos en Oro",
      "firstReferral": "Primer referido",
      "firstReferralBonus": "+50 pts en primer alta válida",
      "goldUnlockedTitle": "Nivel Oro alcanzado",
      "goldUnlockedDesc": "Sigue refiriendo para mantener los beneficios de tu nivel.",
      "goldLevelBadge": "¡Nivel Oro!",
      "allMilestonesUnlocked": "Has desbloqueado todos los hitos",
      "keepInviting": "Sigue invitando para ampliar tu red",
      "silverLevel": "Nivel Plata",
      "goldLevel": "Nivel Oro",
      "silverBonusClub": "Cupón 10% extra en el club",
      "goldBonusMoney": "Bono $25 + badge exclusivo"
    },
    "linkCard": {
      "linkCopiedToast": "¡Enlace copiado al portapapeles!",
      "copyFailed": "No se pudo copiar el enlace",
      "qrDownloaded": "¡Código QR descargado!",
      "shareTitle": "Únete con mi enlace de referido",
      "shareText": "¡Obtén beneficios exclusivos al unirte a través de mi referido!",
      "views": "Vistas",
      "clicks": "Clics",
      "conversions": "Conversiones",
      "created": "Creado",
      "copyLink": "Copiar enlace",
      "showQrCode": "Ver código QR",
      "hideQrCode": "Ocultar código QR",
      "downloadQr": "Descargar QR",
      "shareLink": "Compartir enlace",
      "referralCode": "Código",
      "scanQrHint": "Escanea este código para acceder a tu enlace de referido",
      "active": "Activo",
      "inactive": "Inactivo",
      "analytics": "Analíticas",
      "referralLink": "Enlace de referido",
      "expires": "Expira",
      "createdOn": "Creado",
      "premium": "Premium"
    }
  },
  "referralMessages": {
    "mutual": {
      "label": "Favor mutuo",
      "description": "Corto, ideal para contactos cercanos",
      "body": "¡Hola [Nombre del Amigo/Contacto]! Necesito tu ayuda urgente para ganar mi [Regalo a Ganar] de Enrola. Si aceptas una llamada de [Nombre del representante/Asesor] (es sin compromiso), tu te llevas un regalo. ¿Me echas una mano hoy? ¡Gracias! [Tu Nombre]"
    },
    "urgency": {
      "label": "Recompensa y urgencia",
      "description": "Enfatiza el regalo y el plazo del programa",
      "body": "¡[Nombre del Amigo/Contacto]! Estoy en la recta final para ganar [Regalo a Ganar] (solo tengo 14 dias). ¿Me ayudas? Mi asesor [Nombre del representante/Asesor] te regalara un obsequio solo por escucharlo 10 minutos. ¡Tu ganas, yo gano! ¿Te paso el contacto? [Tu Nombre]"
    },
    "direct": {
      "label": "Cita instantanea",
      "description": "Muy directo para cerrar rapido",
      "body": "[Nombre del Amigo/Contacto], ¡favor! Me quiero ganar [Regalo a Ganar] y necesito un referido. Mi asesor te llamara para coordinar una visita y darte un regalo gratis. ¡Asi los dos ganamos premios! Avísame si puedes. [Tu Nombre]"
    },
    "defaults": {
      "contactName": "[Nombre del contacto]",
      "giftName": "[Regalo a ganar]",
      "advisorName": "[Tu asesor]",
      "userName": "[Tu nombre]"
    }
  },
  "enterprise": {
    "nav": {
      "backToHome": "Volver al inicio",
      "signIn": "Iniciar sesión",
      "userSignIn": "Acceso de usuario",
      "userPortalPrompt": "¿Representante o cliente?"
    },
    "hero": {
      "badge": "Plataforma multi-empresa",
      "title1": "Lance su programa de referidos",
      "titleHighlight": "para su empresa",
      "subtitle": "Cada empresa obtiene un entorno aislado con sus propios usuarios, clientes, representantes, recompensas y analíticas. Inicie sesión con el correo de administrador de su empresa."
    },
    "features": {
      "isolated": {
        "title": "Datos aislados",
        "description": "Cada empresa empieza de cero con su propio alcance de datos."
      },
      "team": {
        "title": "Gestión de equipo completa",
        "description": "Administradores, representantes y clientes — todo ligado a su organización."
      },
      "analytics": {
        "title": "Analíticas por empresa",
        "description": "Rastree referidos, conversiones y recompensas dentro de su tenant."
      },
      "security": {
        "title": "Seguridad empresarial",
        "description": "Separación de datos por empresa con sesiones seguras."
      }
    },
    "benefits": [
      "Configuración instantánea — sin tarjeta de crédito",
      "Cuenta de administrador dedicada para su empresa",
      "Sistema de recompensas y puntos preconfigurado",
      "Escale desde startup hasta empresa"
    ],
    "login": {
      "tab": "Iniciar sesión",
      "title": "Acceso administrador de empresa",
      "subtitle": "Ingrese su correo de administrador y contraseña para gestionar su organización.",
      "submit": "Entrar al panel de administración",
      "submitting": "Iniciando sesión...",
      "success": "¡Bienvenido de nuevo!",
      "error": "No se pudo iniciar sesión",
      "signInFailed": "No se pudo iniciar sesión",
      "cannotReachServer": "No se puede conectar al servidor. ¿Está el backend en ejecución?",
      "noAccount": "¿Empresa nueva?"
    },
    "form": {
      "tab": "Registrarse",
      "title": "Cree la cuenta de su empresa",
      "subtitle": "Se requiere nombre de empresa, correo de administrador y contraseña para comenzar.",
      "companyName": "Nombre de la empresa",
      "companyNamePlaceholder": "ej. Acme Corporation",
      "email": "Correo de administrador",
      "emailPlaceholder": "admin@suempresa.com",
      "password": "Contraseña",
      "passwordPlaceholder": "Mínimo 6 caracteres",
      "confirmPassword": "Confirmar contraseña",
      "confirmPasswordPlaceholder": "Repita su contraseña",
      "submit": "Crear cuenta de empresa",
      "submitting": "Creando cuenta...",
      "success": "¡Cuenta de empresa creada exitosamente!",
      "error": "No se pudo crear la cuenta de empresa",
      "registrationFailed": "No se pudo crear la cuenta de empresa",
      "passwordMismatch": "Las contraseñas no coinciden",
      "passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
      "alreadyHaveAccount": "¿Ya tiene una cuenta?",
      "signInLink": "Iniciar sesión"
    }
  }
};

export default es;
